export type Language = 'et' | 'en' | 'ru';

export const TRANSLATIONS = {
    et: {
        // App title
        APP_TITLE: 'QUALITY DATUM',
        NO_ORGANIZATION_MESSAGE: 'Võta ühendust oma juhiga.',
        NO_TOOLS_MESSAGE: 'Mõõteriistad puuduvad. Palun kontakteeruge oma juhatajaga, et lisada mõõteriistu.',
        SUBSCRIPTION_INACTIVE_TITLE: 'Tellimus pole aktiivne',
        SUBSCRIPTION_INACTIVE_MESSAGE: 'Teie tellimus on aegunud või tühistatud. Palun tellige uuesti profiili lehel, et jätkata kasutajate ja toimetajate haldamist. Kasutajad ja toimetajad ei saa töötada, kuni te ei telli uuesti.',
        SUBSCRIPTION_INACTIVE_ERROR_ADD: 'Tellimus pole aktiivne. Palun tellige uuesti profiili lehel, et lisada kasutajaid.',
        SUBSCRIPTION_INACTIVE_ERROR_ROLE: 'Tellimus pole aktiivne. Palun tellige uuesti profiili lehel, et muuta kasutajate rolle.',

        // Roles
        OPERATOR: 'Operaator',
        ENGINEER: 'Insener',

        // Form labels
        DETAIL_NUMBER: 'Detaili nr. *',
        ORDER_NUMBER: 'Tellimuse nr. *',
        MEASURED_DETAIL_NUMBER: 'Mõõtmise aruande number *',
        REVISION_LABEL: 'Revisjon *',

        // Buttons
        SELECT_NEW: 'VALI UUS',
        SELECT: 'VALI',
        CONTINUE: 'EDASI',

        // File types
        PDF: 'PDF',
        XLSX: 'XLSX',

        // Error messages
        INVALID_PDF_FILE: 'Imporditud fail ei ole sobiv. Palun valige PDF-fail.',
        INVALID_EXCEL_FILE: 'Imporditud fail ei ole sobiv. Palun valige Excel-fail.',

        // Icons/symbols
        ARROW: '→',
        FILE_ICON: '📄',

        // PDF Viewer strings
        BACK_BUTTON: 'Tagasi',
        SAVE_BUTTON: 'Salvesta',
        ORDER_NUMBER_LABEL: 'Tellimuse nr:',
        EDITOR_SAVE_ORDER_NUMBER_DIALOG_TITLE: 'Sisesta tellimuse number',
        EDITOR_SAVE_PDF_MEASURED_DETAIL_LABEL: 'Mõõdetud detaili number:',
        ENGINEER_NAME_LABEL: 'Koostaja:',
        ENGINEER_NAME: 'Vasja Pupkin',
        DETAIL_NUMBER_LABEL: 'Detaili nr:',
        MEASURED_DETAIL_NUMBER_LABEL: 'Mõõtmise aruande nr:',

        // Loading states
        LOADING: 'Laadimine...',

        // PDF loading states
        PDF_LOADING: 'Laen PDF faili...',
        PDF_ERROR: 'PDF faili laadimine ebaõnnestus.',
        PDF_NOT_SELECTED: 'PDF faili pole valitud.',
        NO_PDF_FILE_SELECTED: 'PDF faili pole valitud.',

        G2_RECOGNIZED_LABEL: 'Tuvastatud standard:',
        ISO22081_LINEAR_SIZES: 'Lineaarsed mõõtmed',
        ISO22081_RADIUS_CHAMFER_SIZES: 'Raadius ja faas (R, C)',
        ISO22081_SHAPE_SIZES: 'Kuju mõõtmed',
        ISO22081_ANGULAR_SIZES: 'Nurgamõõtmed',

        HELP_BUTTON_TITLE: 'Klaviatuuri kiirkäsud',
        HELP_MENU_TITLE: 'Klaviatuuri kiirkäsud',
        HELP_ENTER: 'Salvesta / kinnita',
        HELP_F2: 'Salvesta / kinnita',
        HELP_F1: 'Salvesta / kinnita',
        HELP_DELETE: 'Kustuta ristkülik',
        HELP_F4: 'Kustuta ristkülik',
        HELP_ESCAPE: 'Sulge menüü / kustuta kinnitamata ristkülik',
        HELP_ESCAPE_USER: 'Sulge menüü',
        HELP_TOOL_SELECT: 'Vali tööriist',
        HELP_PLUS: 'Vali ok',
        HELP_MINUS: 'Vali no ok',
        HELP_CLOSE: 'Sulge',

        SETTINGS_BUTTON_TITLE: 'Seaded',
        SETTINGS_MENU_TITLE: 'PDF seaded',
        SETTINGS_SEQUENCE_MEASUREMENT: 'Järjestusmõõtmine',
        SETTINGS_EXAM_MODE: 'Eksam',
        EXAM_SELECT_TOOL: 'Vali tööriist',
        EXAM_TOOL_CORRECT: 'Õige tööriist',
        EXAM_TOOL_INCORRECT: 'Vale tööriist',
        SETTINGS_DOWNLOAD_PATH: 'Aruannete kaust',
        SETTINGS_SETTINGS_PDF_PATH: 'Seadistuste kaust',
        SETTINGS_CHOOSE_FOLDER: 'Vali kaust',
        SETTINGS_CLEAR_FOLDER: 'Tühjenda',
        SETTINGS_FOLDER_NOT_SELECTED: 'Kaust pole valitud',
        SETTINGS_APPLY: 'Rakenda',
        SAVE_SUCCESS_TITLE: 'Salvestamine õnnestus!',
        SAVE_SUCCESS_TITLE_LOCAL_SERVER: 'Salvestatud ettevõtte kohalikku serverisse!',
        SAVE_SUCCESS_PATH: 'Fail: {fileName}\nKaust: {folderName}',
        SAVE_SUCCESS_DEFAULT_FOLDER: 'Brauseri vaikimisi allalaadimise kaust',
        SAVE_SUCCESS_FILE_LABEL: 'Fail',
        SAVE_SUCCESS_FOLDER_LABEL: 'Kaust',
        SAVE_SUCCESS_OPEN_PDF: 'Ava PDF',
        SAVE_SUCCESS_OK: 'OK',

        // Pagination
        PREVIOUS_PAGE: 'Eelmine',
        NEXT_PAGE: 'Järgmine',
        PAGE_LABEL: 'Leht',
        PAGE: 'Leht',

        // Context menu and inputs
        MEASUREMENT_TOOL_PLACEHOLDER: '...',
        TOOL_NUMBER_PLACEHOLDER: '...',
        NOMINAL_DIMENSION_LABEL: 'Nominaalmõõt',
        NOMINAL_DIMENSION_PLACEHOLDER: '...',
        DESCRIPTION_LABEL: 'Kirjeldus',
        TOLERANCE_PLUS_LABEL: '+',
        TOLERANCE_MINUS_LABEL: '-',
        TOLERANCE_PLUS_PLACEHOLDER: '...',
        TOLERANCE_MINUS_PLACEHOLDER: '...',
        MEASUREMENT_RESULT_PLACEHOLDER: '0.00',

        // Tolerance buttons
        SMALL_TOLERANCE_BUTTON: '+ -',
        MEDIUM_TOLERANCE_BUTTON: '+ +',
        LARGE_TOLERANCE_BUTTON: '- -',

        // Excel export headers
        MEASUREMENT_NUMBER: 'Mõõt',
        TOOL: 'Tööriist',
        NOMINAL_DIMENSION: 'Nominaalmõõt',
        MEASUREMENT_RESULT: 'Mõõtmistulemus',
        RESULT: 'Tulemus',
        MEASURED_DETAIL_NUMBER_EXPORT: 'Mõõtmise aruande number',
        COMPLETED: 'Täidetud?',
        TOLERANCE_PLUS: 'Upper tolerance',
        TOLERANCE_MINUS: 'Lower tolerance',
        TOLERANCE_TYPE: 'Tolerantsi tüüp',
        TIME: 'Aeg',
        X_POSITION: 'X positsioon',
        Y_POSITION: 'Y positsioon',
        WIDTH: 'Laius',
        HEIGHT: 'Kõrgus',
        DETAIL_NUMBER_EXPORT: 'Detaili number',

        // Boolean values
        YES: 'Jah',
        NO: 'Ei',

        // File names
        UNKNOWN: 'tundmatu',
        SETUP_DATA_SHEET: 'Seadistamisandmed',
        USER_REPORT_DATA_SHEET: 'Mõõtmised',

        // Error messages
        ROLE_SELECTION_ERROR: 'Roll peab olema valitud. Palun valige kas operaator või insener.',

        // Measurement tools
        CALIPER: 'Nihik',
        CALIBER_TOOL: 'Nihik',
        MICROMETER: 'Mikromeeter',
        DIGITAL_INSIDE_MICROMETER: 'Sisemikromeeter',
        DIAL_INDICATOR: 'Kellindikaator',
        STOPWATCH: 'Kellindikaator',
        HEIGHT_GAUGE: 'Kõrgusemõõtja',
        HEIGHT_MEASURING_JACK: 'Kõrgusemõõtja',
        THREAD_GAUGE: 'Kork keermekaliiber',
        SCREW_DRIVER: 'Kork keermekaliiber',
        TOOL_7: 'NO-GO keerme rõngas kaliiber',
        TOOL_8: 'GO keerme rõngas kaliiber',
        TOOL_9: '3-punktiline sisemine ava mikromeeter',
        TOOL_10: 'Sügavuse mikromeeter',
        TOOL_11: 'Tihvtkaliiber',
        MULTIMETER: 'Multimeeter',

        // Registration page
        USERNAME_LABEL: 'Kasutajanimi',
        USERNAME_PLACEHOLDER: 'Sisesta kasutajanimi',
        EMAIL_LABEL: 'E-post',
        EMAIL_PLACEHOLDER: 'Sisesta e-posti aadress',
        PASSWORD_LABEL: 'Parool',
        PASSWORD_PLACEHOLDER: 'Sisesta parool',
        CONFIRM_PASSWORD_LABEL: 'Kinnita parool',
        CONFIRM_PASSWORD_PLACEHOLDER: 'Kinnita parool',
        ORGANIZATION_LABEL: 'Ettevõtte',
        ORGANIZATION_PLACEHOLDER: 'Sisesta ettevõtte nimi, lühidalt',
        ORGANIZATION_IMAGE_LABEL: 'Logo ( PNG või JPEG )',
        ORGANIZATION_LOGO_REQUIRED_ERROR: 'Palun vali ettevõtte logo (PNG või JPEG).',
        ORGANIZATION_LOGO_FORMAT_ERROR: 'Ettevõtte logo peab olema PNG või JPEG formaadis.',
        ORGANIZATION_LOGO_PREVIEW: 'Ettevõtte logo eelvaade',
        USE_DEFAULT_LOGO_LABEL: 'Kasuta vaikimisi logo',
        OR_LABEL: 'või',
        ROLE_LABEL: 'Roll',
        SELECT_ROLE_PLACEHOLDER: 'Vali roll',
        ROLE1: 'Juht',
        ROLE2: 'Kasutaja',

        // Pricing plans
        PRICING_PLANS_TITLE: 'Vali pakett',
        YOUR_PLAN_TITLE: 'Sinu pakett',
        BASIC_PLAN_TITLE: 'Basic',
        PREMIUM_PLAN_TITLE: 'Premium',
        ULTIMATE_PLAN_TITLE: 'Ultimate',
        MONTHLY_PRICE: 'EUR/kuu',
        EDITORS_LABEL: 'toimetajad',
        USERS_LABEL: 'kasutajad',
        MEASUREMENT_TOOLS_LABEL: 'mõõteriistad',
        ADDITIONAL_TOOLS_LABEL: 'lisamõõteriistad',
        ADDITIONAL_TOOL_PRICE: 'EUR/kuu iga lisamõõteriist',
        UNLIMITED_LABEL: 'piiramatult',
        SELECT_PLAN_BUTTON: 'Vali pakett',
        PLAN_ACTIVATED_BUTTON: 'Aktiivne',
        CONTACT_US_BUTTON: 'Saada päring',
        PLAN_DOWNGRADE_WARNING_TITLE: 'Hoiatus: Plaani muutmine',
        PLAN_DOWNGRADE_WARNING_MESSAGE: 'Kui muudate plaani odavamaks, kustutatakse kõik teie kasutajad ja toimetajad. See toiming on pöördumatu. Kas soovite jätkata?',
        PLAN_DOWNGRADE_CONFIRM_BUTTON: 'Jätka',
        PLAN_DOWNGRADE_CANCEL_BUTTON: 'Tühista',

        REGISTER_BUTTON: 'Registreeru',
        REGISTERING_BUTTON: 'Registreerimine...',
        PASSWORDS_DONT_MATCH_ERROR: 'Paroolid ei ühti',
        PASSWORD_TOO_SHORT_ERROR: 'Parool peab olema vähemalt 8 tähemärki pikk',
        PASSWORD_TOO_LONG_ERROR: 'Parool ei tohi olla pikem kui 128 tähemärki',
        PASSWORD_MISSING_UPPERCASE_ERROR: 'Parool peab sisaldama vähemalt üht suurt tähte (A-Z)',
        PASSWORD_MISSING_LOWERCASE_ERROR: 'Parool peab sisaldama vähemalt üht väikest tähte (a-z)',
        PASSWORD_MISSING_DIGIT_ERROR: 'Parool peab sisaldama vähemalt üht numbrit (0-9)',
        PASSWORD_MISSING_SPECIAL_CHAR_ERROR: 'Parool peab sisaldama vähemalt üht erimärki (!@#$%^&*()_+-=[]{}|;:,.<>?)',
        PASSWORD_REPEATED_CHARS_ERROR: 'Parool ei tohi sisaldada korduvaid tähemärke järjest',
        PASSWORD_COMMON_SEQUENCE_ERROR: 'Parool ei tohi sisaldada tavalisi järjestusi (123, abc, qwe jne)',
        FILL_ALL_FIELDS_ERROR: 'Palun täitke kõik väljad',
        REGISTRATION_ERROR: 'Registreerimisel tekkis viga',
        REGISTRATION_SUCCESS: 'Registreerimine õnnestus!',
        REGISTRATION_RATE_LIMIT_ERROR: 'Liiga palju registreerimiskatseid. Palun proovige hiljem uuesti.',
        REGISTRATION_RATE_LIMIT_MESSAGE: 'Palun oodake enne järgmist katseid',

        // Payment Error Messages
        PAYMENT_ERROR: 'Makse viga',
        PAYMENT_CANCELLED: 'Makse tühistati',
        PAYMENT_FAILED: 'Makse ebaõnnestus',
        PAYMENT_PROCESSING_ERROR: 'Makse töötlemisel tekkis viga',
        PAYMENT_SESSION_EXPIRED: 'Makse sessioon on aegunud',
        PAYMENT_NOT_COMPLETED: 'Makse ei lõppenud',
        PROCESSING_PAYMENT: 'Töötleme makset...',
        PLEASE_WAIT: 'Palun oodake',

        // Password re-entry after payment (security feature)
        PAYMENT_SUCCESS_ENTER_PASSWORD_TITLE: 'Makse õnnestus',
        PAYMENT_SUCCESS_ENTER_PASSWORD_DESC: 'Turvalisuse tagamiseks sisestage oma parool registreerimise lõpetamiseks.',
        COMPLETE_REGISTRATION_BUTTON: 'Lõpeta registreerimine',

        // Firebase Auth Error Messages
        FIREBASE_EMAIL_ALREADY_IN_USE: 'See e-posti aadress on juba kasutusel',
        FIREBASE_INVALID_EMAIL: 'Vigane e-posti aadress',
        FIREBASE_OPERATION_NOT_ALLOWED: 'See toiming pole lubatud',
        FIREBASE_WEAK_PASSWORD: 'Parool on liiga nõrk',
        FIREBASE_USER_DISABLED: 'See kasutaja on keelatud',
        FIREBASE_USER_NOT_FOUND: 'Kasutajat ei leitud',
        FIREBASE_WRONG_PASSWORD: 'Vale parool',
        FIREBASE_INVALID_CREDENTIAL: 'Vale kasutajanimi või parool',
        FIREBASE_TOO_MANY_REQUESTS: 'Liiga palju ebaõnnestunud katseid. Proovige hiljem uuesti',
        FIREBASE_NETWORK_REQUEST_FAILED: 'Võrgu viga. Kontrollige internetiühendust',
        FIREBASE_REQUIRES_RECENT_LOGIN: 'See toiming nõuab hiljutist sisselogimist',

        // Login page
        LOGIN_EMAIL_LABEL: 'E-mail',
        LOGIN_EMAIL_PLACEHOLDER: 'Sisesta e-posti aadress',
        LOGIN_PASSWORD_LABEL: 'Parool',
        LOGIN_PASSWORD_PLACEHOLDER: 'Sisesta parool',
        LOGIN_BUTTON: 'Logi sisse',
        LOGIN_LOADING: 'Sisselogimine...',
        LOGIN_ERROR: 'Sisselogimisel tekkis viga',
        LOGIN_FILL_FIELDS_ERROR: 'Palun sisestage e-posti aadress ja parool',
        FORGOT_PASSWORD_BUTTON: 'Unustasid parooli?',
        FORGOT_PASSWORD_ALERT: 'Parooli taastamise funktsioon tuleb varsti!',
        RESET_PASSWORD_TITLE: 'Taasta parool',
        RESET_PASSWORD_EMAIL_LABEL: 'E-posti aadress',
        RESET_PASSWORD_EMAIL_PLACEHOLDER: 'Sisesta oma e-posti aadress',
        RESET_PASSWORD_EMAIL_REQUIRED: 'Palun sisesta e-posti aadress',
        RESET_PASSWORD_ERROR: 'Parooli taastamisel tekkis viga',
        RESET_PASSWORD_SUCCESS: 'Parooli taastamise link saadeti teie e-posti aadressile.',
        RESET_PASSWORD_INSTRUCTIONS: 'Palun kontrollige oma e-posti ja järgige juhiseid parooli taastamiseks.',
        RESET_PASSWORD_CANCEL: 'Tühista',
        RESET_PASSWORD_SENDING: 'Saadan...',
        RESET_PASSWORD_SEND: 'Saada',

        // Contact Us page
        CONTACT_US_TITLE: 'Võta meiega ühendust',
        CONTACT_US_SUBTITLE: 'Ultimate paketi jaoks',
        CONTACT_US_DESCRIPTION: 'Kui soovid arutada meie toodet või saada pakkumist personaalse versiooni jaoks, täida vorm.',
        NAME_LABEL: 'Nimi',
        NAME_PLACEHOLDER: 'Sisesta oma nimi',
        COMPANY_LABEL: 'Ettevõte',
        COMPANY_PLACEHOLDER: 'Sisesta ettevõtte nimi',
        PHONE_LABEL: 'Telefon',
        PHONE_PLACEHOLDER: 'Sisesta telefoninumber',
        MESSAGE_LABEL: 'Sõnum',
        MESSAGE_PLACEHOLDER: 'Kirjelda oma vajadusi ja küsimusi...',
        SEND_MESSAGE_BUTTON: 'Saada sõnum',
        SENDING_MESSAGE_BUTTON: 'Saadan...',
        MESSAGE_SENT_SUCCESS: 'Sõnum saadetud edukalt!',
        MESSAGE_SENT_ERROR: 'Sõnumi saatmisel tekkis viga',
        REQUIRED_FIELD_ERROR: 'See väli on kohustuslik',
        INVALID_EMAIL_ERROR: 'Palun sisesta kehtiv e-posti aadress',
        INVALID_PHONE_ERROR: 'Palun sisesta kehtiv telefoninumber',

        // No Connection Page
        NO_CONNECTION_TITLE: 'Ühendus puudub',
        NO_CONNECTION_DESCRIPTION: 'Rakenduse korralikuks tööks on vajalik internetiühendus. Palun kontrollige oma internetiühendust ja proovige uuesti.',
        NO_CONNECTION_TIPS_TITLE: 'Kontrollige järgmist:',
        NO_CONNECTION_TIP_1: 'Internetiühenduse olemasolu',
        NO_CONNECTION_TIP_2: 'Wi-Fi või mobiilse andmeühenduse seadistusi',
        NO_CONNECTION_TIP_3: 'Võrgu tugevust',
        NO_CONNECTION_TIP_4: 'Firewall või tulemüüri seadistusi',
        RETRY_BUTTON: 'Proovi uuesti',

        // Profile Page
        PROFILE_TITLE: 'Minu profiil',
        PROFILE_NAME_LABEL: 'Nimi',
        PROFILE_EMAIL_LABEL: 'E-posti aadress',
        PROFILE_LANGUAGE_LABEL: 'Rakenduse keel',
        PROFILE_REPORT_LANGUAGE_LABEL: 'Aruande keel',
        PROFILE_LANGUAGE_ET: 'Eesti',
        PROFILE_LANGUAGE_EN: 'English',
        PROFILE_LANGUAGE_RU: 'Русский',
        PROFILE_EMAIL_VERIFIED_LABEL: 'E-posti kinnitatud',
        PROFILE_ROLE_LABEL: 'Roll',
        PROFILE_ORGANIZATION_LABEL: 'Organisatsioon',
        PROFILE_ORGANIZATION_PLACEHOLDER: 'Sisestage organisatsiooni nimi',
        PROFILE_SUBSCRIPTION_PLAN_LABEL: 'Tellimuse plaan',
        PROFILE_EDITOR_LIMIT_LABEL: 'Toimetajate limiit',
        PROFILE_USER_LIMIT_LABEL: 'Kasutajate limiit',
        PROFILE_SAVE_ORGANIZATION: 'Salvesta organisatsioon',
        PROFILE_SAVING: 'Salvestamine...',
        PROFILE_SAVE: 'Salvesta',
        PROFILE_LOGO_LABEL: 'Logo',
        PROFILE_LOGO_CHANGE: 'Muuda logo',
        PROFILE_LOGO_USE_DEFAULT: 'Kasuta vaikimisi logo',
        PROFILE_LOGO_SELECT_FILE: 'Vali fail',
        PROFILE_LOGO_ERROR_NO_FILE: 'Palun vali pildifail',
        PROFILE_LOGO_ERROR_UPLOAD: 'Viga logo salvestamisel',
        PROFILE_PDF_WORKFLOW_LABEL: 'Kuidas operaatorid ja toimetajad PDF-e kasutavad',
        PROFILE_PDF_WORKFLOW_MANUAL: 'Manuaalne valik',
        PROFILE_PDF_WORKFLOW_LOCAL_SERVER: 'Kohalik server',
        PROFILE_PDF_WORKFLOW_CLOUD_DB: 'Cloud DB',
        PROFILE_PDF_WORKFLOW_CLOUD_DB_HELP:
            'Aruanded ja seadistused salvestatakse pilve (Firebase).',
        SAVE_SUCCESS_TITLE_CLOUD_DB: 'Salvestatud pilve!',
        PROFILE_PDF_WORKFLOW_MANUAL_HELP:
            'Toimetaja ja operaator valivad käsitsi PDF failid.',
        LOCAL_SERVER_URL_LABEL: 'Kohaliku serveri URL',
        LOCAL_SERVER_ENABLED_LABEL: 'Lubatud (operaatorid kasutavad seda serverit)',
        LOCAL_SERVER_LAST_SEEN: 'Viimati nähtud: ',
        LOCAL_SERVER_VERSION_PREFIX: ' (versioon ',
        LOCAL_SERVER_NEVER_SEEN: 'Server pole veel teatanud',
        LOCAL_SERVER_COMPANY_ID_LABEL: 'Ettevõtte ID (kohaliku serveri paigalduseks)',
        LOCAL_SERVER_COMPANY_ID_HINT:
            'See sama väärtus läheb veebivormis /setup väljale „Company ID“. IT võib avada ka lingi kuju http://SERVER_IP:8765/setup?companyId=SAMA_ID — välja täidetakse ette.',
        LOCAL_SERVER_TOKEN_LABEL: 'Registreerimistunnus',
        LOCAL_SERVER_TOKEN_BTN: 'Väljasta registreerimistunnus',
        LOCAL_SERVER_TOKEN_BTN_LOADING: 'Väljastamine...',
        LOCAL_SERVER_TOKEN_HINT: 'Edasta tunnus IT-inseneri kätte, kes paigaldab kohaliku serveri. Ühekordne kasutus, kehtib 24 tundi.',
        LOCAL_SERVER_TOKEN_EXPIRES_AT: 'Kehtib kuni: ',
        LOCAL_SERVER_TOKEN_COPY: 'Kopeeri',
        LOCAL_SERVER_TOKEN_COPIED: 'Kopeeritud',
        LOCAL_SERVER_TOKEN_ERROR: 'Tunnuse väljastamine ebaõnnestus',
        LOCAL_SERVER_SAVED: 'Salvestatud',
        LOCAL_SERVER_SAVE_ERROR: 'Kohaliku serveri seadete salvestamine ebaõnnestus',
        LOCAL_SERVER_INVALID_URL: 'URL peab algama https:// või http://',
        LOCAL_SERVER_PUBLISH_FAILED: 'Salvestatud lokaalselt, aga ei õnnestunud avaldada revisjooni kohalikus serveris: ',
        LOCAL_SERVER_NO_REVISIONS: 'Sellele detailile pole avaldatud revisjoone',
        HOME_EDITOR_REVISION_UPLOAD_NEW: 'Uus revisjon — laadi PDF üles',
        HOME_EDITOR_REVISION_ALREADY_EXISTS: 'Sellise numbriga revisjon on juba olemas',
        LOCAL_SERVER_REPORT_UPLOAD_FAILED: 'Serverisse salvestus ebaõnnestus. ',
        LOCAL_SERVER_SAVE_FAILED_MODAL_TITLE: 'Serverisse salvestamine ebaõnnestus',
        REPORTS_NAV_BTN: 'Aruanded',
        REPORTS_TITLE: 'Aruanded',
        REPORTS_FILTER_DETAIL: 'Detaili nr',
        REPORTS_FILTER_ORDER: 'Tellimuse nr',
        REPORTS_FILTER_OPERATOR: 'Operaatori UID',
        REPORTS_APPLY_FILTERS: 'Rakenda',
        REPORTS_RESET_FILTERS: 'Lähtesta',
        REPORTS_EMPTY: 'Aruandeid pole',
        REPORTS_TYPE_TO_SEARCH: 'Otsimiseks alustage tippimist ülalolevas väljas.',
        REPORTS_NEED_LOGIN: 'Aruannete vaatamiseks logi sisse.',
        REPORTS_NO_LOCAL_SERVER: 'Aruanded salvestatakse teie ettevõtte lokaalses serveris. Palu juhatajal seadistada see profiilis.',
        REPORTS_COL_DATE: 'Kuupäev',
        REPORTS_COL_DETAIL: 'Detail',
        REPORTS_COL_REVISION: 'Revisjon',
        REPORTS_COL_ORDER: 'Tellimus',
        REPORTS_COL_MEAS_NR: 'Mõõt. nr',
        REPORTS_COL_OPERATOR: 'Operaator',
        REPORTS_COL_SIZE: 'Suurus',
        REPORTS_COL_ACTION: 'Tegevus',
        REPORTS_OPEN_REPORT_PDF: 'Ava aruande PDF uues vahekaardis',
        REPORTS_OPEN_PDF_POPUP_BLOCKED: 'PDF avamine ebaõnnestus: brauser blokeeris uue akna. Lubage hüpikaknad selle saidi jaoks.',
        REPORTS_DOWNLOAD_REPORT_PDF: 'Laadi aruande PDF alla',
        REPORTS_DELETE_CONFIRM_TITLE: 'Kinnita aruande kustutamine',
        REPORTS_DELETE_CONFIRM_LOCAL: 'Kas kustutada see aruanne jäädavalt kohalikust serverist?',
        REPORTS_DELETE_CONFIRM_CLOUD: 'Kas kustutada see aruanne jäädavalt pilve andmebaasist?',
        REPORTS_PREV: 'Eelmine',
        REPORTS_NEXT: 'Järgmine',
        REPORTS_PAGE_INFO_FORMAT: '{from}–{to} / {total}',
        REPORTS_LOADING: 'Laadimine…',
        SAVED_SETTINGS_TITLE: 'Seaded',
        SAVED_SETTINGS_TYPE_TO_SEARCH: 'Otsimiseks alustage tippimist allolevas väljas.',
        SAVED_SETTINGS_EMPTY: 'Vasteid ei leitud',
        SAVED_SETTINGS_OPEN_PDF: 'Ava seadete PDF uues vahekaardis',
        SAVED_SETTINGS_EDIT: 'Muuda',
        SAVED_SETTINGS_COL_STATUS: 'Olek',
        SAVED_SETTINGS_COL_EDITOR: 'Koostaja',
        SAVED_SETTINGS_DELETE_CONFIRM_TITLE: 'Kinnita seadete kustutamine',
        SAVED_SETTINGS_DELETE_CONFIRM_LOCAL: 'Kas kustutada see salvestatud seadete kirje jäädavalt kohalikust serverist?',
        SAVED_SETTINGS_DELETE_CONFIRM_CLOUD: 'Kas kustutada see salvestatud seadete kirje jäädavalt pilve andmebaasist?',
        PROFILE_LOGOUT: 'Logi välja',
        PROFILE_DELETE_PROFILE: 'Kustuta profiil',
        PROFILE_DELETING: 'Kustutamine...',
        PROFILE_DELETE_CONFIRM_TITLE: 'Kustuta profiil',
        PROFILE_DELETE_CONFIRM_MESSAGE: 'Kas olete kindel, et soovite oma profiili kustutada? See toiming on pöördumatu ja kõik teie andmed kustutatakse jäädavalt.',
        PROFILE_DELETE_WARNING: 'Hoiatus: Te ei saa seda toimingut tagasi võtta.',
        PROFILE_PASSWORD_CONFIRM_LABEL: 'Parool kinnitamiseks',
        PROFILE_PASSWORD_PLACEHOLDER: 'Sisestage oma parool',
        PROFILE_CANCEL: 'Tühista',
        PROFILE_DELETE: 'Kustuta',
        PROFILE_LOADING_FAILED: 'Profiili laadimine ebaõnnestus',
        PROFILE_BACK: 'Tagasi',
        PROFILE_PROCESSING_PAYMENT: 'Makse töötlemisel...',
        PROFILE_LOADING: 'Laadimine...',
        PROFILE_PASSWORD_REQUIRED: 'Palun sisestage parool',
        PROFILE_WRONG_PASSWORD: 'Vale parool',
        PROFILE_RELOGIN_REQUIRED: 'Palun logige uuesti sisse ja proovige uuesti',
        PROFILE_DELETE_ERROR: 'Viga profiili kustutamisel',
        PROFILE_CHANGE_PASSWORD: 'Muuda parool',
        PROFILE_CHANGE_PASSWORD_TITLE: 'Muuda parool',
        PROFILE_CHANGE_PASSWORD_MESSAGE: 'Sisestage oma praegune parool ja uus parool',
        PROFILE_CURRENT_PASSWORD_LABEL: 'Praegune parool',
        PROFILE_NEW_PASSWORD_LABEL: 'Uus parool',
        PROFILE_CONFIRM_NEW_PASSWORD_LABEL: 'Kinnita uus parool',
        PROFILE_CURRENT_PASSWORD_PLACEHOLDER: 'Sisestage praegune parool',
        PROFILE_NEW_PASSWORD_PLACEHOLDER: 'Sisestage uus parool',
        PROFILE_CONFIRM_NEW_PASSWORD_PLACEHOLDER: 'Kinnitage uus parool',
        PROFILE_CHANGING_PASSWORD: 'Parooli muutmine...',
        PROFILE_PASSWORD_CHANGED: 'Parool muudetud edukalt',
        PROFILE_PASSWORD_CHANGE_ERROR: 'Viga parooli muutmisel',
        PROFILE_PASSWORD_MISMATCH: 'Uued paroolid ei ühti',
        PROFILE_NEW_PASSWORD_REQUIRED: 'Palun sisestage uus parool',
        PROFILE_CONFIRM_PASSWORD_REQUIRED: 'Palun kinnitage uus parool',
        PROFILE_ORGANIZATION_SAVE_ERROR: 'Viga organisatsiooni salvestamisel',
        PROFILE_REMOVE_TOOLS_ERROR: 'Viga mõõteriistade eemaldamisel',
        PROFILE_UNKNOWN_ERROR: 'Tundmatu viga',
        CHECKOUT_SESSION_ERROR: 'Kassasseansi loomine ebaõnnestus',
        ERROR_OCCURRED: 'Tekkis viga',
        ERROR_REMOVING_MEMBERS: 'Viga liikmete eemaldamisel',

        // Roles
        ROLE_ADMIN: 'Administraator',
        ROLE_MANAGER: 'Juhataja',
        ROLE_EDITOR: 'Toimetaja',
        ROLE_USER: 'Kasutaja',

        // Remove Tools Section
        REMOVE_TOOLS_TITLE: 'Kustuta mõõteriistad',
        REMOVE_TOOLS_DESCRIPTION: 'Kustutab kõik mõõteriistad, kui vajate neid muuta või kustutada kasutamata riistad.',
        REMOVE_TOOLS_CONFIRM_TITLE: 'Kinnita mõõteriistade kustutamist',
        REMOVE_TOOLS_CONFIRM_MESSAGE: 'Kas olete kindel, et soovite kustutada kõik mõõteriistad? See toiming maksab 10 EUR ja kustutab kõik mõõteriistad (sh kohandatud tööriistad ja nende pildid).',
        REMOVE_TOOLS_CONFIRM: 'Kinnita',
        REMOVE_TOOLS_PROCESSING: 'Töötlemine...',

        // Add Tool Confirmation
        ADD_TOOL_CONFIRM_TITLE: 'Lisa mõõteriist',
        ADD_TOOL_CONFIRM_MESSAGE: 'Kas olete kindel, et soovite lisada selle mõõteriista? Peale lisamist kustutada või muuta saab ainult lisatasu eest. Info profiili seadetes.',
        ADD_TOOL_WARNING: 'Hoiatus: Te ei saa seda toimingut tasuta tagasi võtta.',
        ADD_TOOL_CONFIRM: 'Kinnita',

        // Dashboard Page
        DASHBOARD_ENTER_EMAIL: 'Palun sisesta e-posti aadress',
        DASHBOARD_ENTER_EMAIL_PLACEHOLDER: 'Sisesta e-posti aadress ja vajuta Lisa...',
        DASHBOARD_PREVIEW: 'Eelvaade',
        DASHBOARD_INVALID_EMAIL: 'Vigane e-posti aadress',
        DASHBOARD_USER_NOT_LOGGED_IN: 'Kasutaja ei ole sisse logitud',
        DASHBOARD_ADD_EMAIL_ERROR: 'Viga emaili lisamisel.',
        DASHBOARD_USER_ALREADY_IN_COMPANY: 'See kasutaja on juba ettevõttes',
        DASHBOARD_ADD_USER_ERROR: 'Viga kasutaja lisamisel',
        DASHBOARD_USER_ADDED_SUCCESS: 'Kasutaja lisatud ettevõttesse',
        DASHBOARD_UPDATE_ROLE_ERROR: 'Viga rolli uuendamisel',
        DASHBOARD_REMOVE_USER_ERROR: 'Viga kasutaja eemaldamisel',
        DASHBOARD_EDITOR_LIMIT_REACHED: 'Toimetajate limiit saavutatud',
        DASHBOARD_USER_LIMIT_REACHED: 'Kasutajate limiit saavutatud',
        DASHBOARD_TOOL_LIMIT_REACHED: 'Mõõteriistade limiit saavutatud',
        DASHBOARD_ADD_TOOL_ERROR: 'Viga tööriista lisamisel',
        DASHBOARD_REMOVE_TOOL_ERROR: 'Viga tööriista eemaldamisel',
        DASHBOARD_DELETE_TOOL: 'Kustuta tööriist',
        DASHBOARD_DELETE_TOOL_CONFIRM_TITLE: 'Kinnita tööriista kustutamist',
        DASHBOARD_DELETE_TOOL_CONFIRM_MESSAGE: 'Kas olete kindel, et soovite kustutada tööriista',
        DASHBOARD_DELETE_TOOL_WARNING: 'See toiming maksab 1 EUR + KM ja kustutab tööriista jäädavalt (sh kohandatud tööriista pildid, kui see on kohandatud tööriist).',
        DASHBOARD_DELETE_TOOL_CONFIRM: 'Kinnita ja maksa',
        DASHBOARD_PROCESSING: 'Töötlemine...',
        DASHBOARD_TOOL_NAME_REQUIRED: 'Palun sisesta tööriista nimi',
        DASHBOARD_ADD_CUSTOM_TOOL_ERROR: 'Viga kohandatud tööriista lisamisel',
        DASHBOARD_SELECT_IMAGE_FILE: 'Palun vali pildifail',
        DASHBOARD_SELECT_FILE: 'Vali fail',
        DASHBOARD_SAVE: 'Salvesta',
        DASHBOARD_DELETE: 'Kustuta',
        DASHBOARD_CANCEL: 'Tühista',
        DASHBOARD_EXIT: 'Välju',
        DASHBOARD_ADD_TOOL: 'Lisa tööriist',
        DASHBOARD_ADD_CUSTOM_TOOL: 'Lisa oma',
        DASHBOARD_SAVING: 'Salvestamine...',
        DASHBOARD_ADD: 'Lisa',
        DASHBOARD_SENDING: 'Saadan...',
        DASHBOARD_ADD_CUSTOM_TOOL_TITLE: 'Lisa kohandatud tööriist',
        DASHBOARD_CUSTOM_TOOL_NAME_LABEL: 'Tööriista nimi *',
        DASHBOARD_CUSTOM_TOOL_NAME_PLACEHOLDER: 'Sisesta tööriista nimi',
        DASHBOARD_CUSTOM_TOOL_COLOR_LABEL: 'Värv *',
        DASHBOARD_SELECT_COLOR: 'Vali värv',
        DASHBOARD_TOOL_COLOR_REQUIRED: 'Värv on kohustuslik',
        DASHBOARD_IMAGE_FILE_LABEL: 'Pildifail *',
        DASHBOARD_IMAGE_FILE_NOTE: 'Parema kasutajaliidese jaoks vali pilt ilma taustata. Pilt peaks olema maastiku orientatsioonis',
        DASHBOARD_IMAGE_FILE_HELP: 'Toetatud formaadid: PNG, JPEG, GIF, WebP. Maksimaalne suurus: 5MB',
        DASHBOARD_PRECISION_CLASS_LABEL: 'Täpsusklass *',
        DASHBOARD_PRECISION_CLASS_PLACEHOLDER: 'Sisesta täpsusklass',
        DASHBOARD_PRECISION_CLASS_REQUIRED: 'Täpsusklass on kohustuslik',
        DASHBOARD_PRECISION_CLASS_HELP: 'Vajalik mõõterapporti vorminguks.',
        DASHBOARD_TOOL_WITHOUT_MEASUREMENT: 'Tööriist ilma mõõtmisteta',
        DASHBOARD_TOOL_WITHOUT_MEASUREMENT_DESCRIPTION: 'Aktiveerige, kui Teie tööriist on fikseeritud suurusega',
        DASHBOARD_MINIMUM_PRECISION_LABEL: 'Minimaalne numbri täpsus',
        DASHBOARD_MINIMUM_PRECISION_HELP: 'Minimaalne väärtuse täpsus, mida kasutaja peab sisestama mõõtmise esitamiseks.',
        DASHBOARD_TOOL_IMAGE_REQUIRED: 'Pildifail on kohustuslik',
        DASHBOARD_IMAGE_TOO_LARGE: 'Pildifail on liiga suur (maksimum 5MB)',
        DASHBOARD_EDITORS_LABEL: 'Toimetajad:',
        DASHBOARD_USERS_LABEL: 'Kasutajad:',
        DASHBOARD_TOOLS_LABEL: 'Mõõteriistad:',
        DASHBOARD_MEMBERS_TITLE: 'Ettevõtte liikmed',
        DASHBOARD_TOOLS_TITLE: 'Mõõteriistad',
        DASHBOARD_USER_ROLE: 'Kasutaja',
        DASHBOARD_EDITOR_ROLE: 'Toimetaja',
        DASHBOARD_NO_MEMBERS: 'Ettevõttes pole veel liikmeid',
        DASHBOARD_ALL_TOOLS_ADDED: 'Kõik tööriistad on juba lisatud',
        DASHBOARD_CONFIRM_DELETE_TITLE: 'Kinnita kustutamine',
        DASHBOARD_CONFIRM_DELETE_MESSAGE: 'Kas oled kindel, et soovid eemaldada kasutaja',
        DASHBOARD_DELETE_WARNING: 'Seda tegevust ei saa tagasi võtta.',
        DASHBOARD_LOADING: 'Laadimine...',

        // Home Page
        HOME_EXCEL_ERROR: 'Viga Excel faili töötlemisel',
        HOME_DELETE_FILE: 'Kustuta fail',
        PDF_NO_EMBEDDED_SETTINGS: 'PDF fail ei sisalda seadistusi. Vali fail, millel on sees seadistused.',
        PDF_SETTINGS_EXTRACTED: 'Seadistused leitud',
        SAVE_PDF_WITH_SETTINGS: 'Salvesta PDF seadistustega',

        // PdfViewer
        PDFVIEWER_NO_TOOLS_MESSAGE: 'Mõõteriistad puuduvad. Palun kontakteeruge juhatajaga.',
        PDFVIEWER_TOOL_NUMBER_RANGE: 'Palun sisestage number vahemikus 1 kuni',
        PDFVIEWER_MAX_TOOL_NUMBER: 'Maksimaalne number on',
        PDFVIEWER_MIN_TOOL_NUMBER: 'Number peab olema vähemalt 1',
        PDFVIEWER_HOLE_SHAFT_REQUIRED: 'Võll ja ava peavad olema valitud rippmenüüst',
        PDFVIEWER_HOLE_SHAFT_STANDARD_REQUIRED: 'Vali võlli ja ava standard standardi nurgast vasakul...',
        PDFVIEWER_LOADING: 'Laadimine...',
        PDFVIEWER_RECOGNIZE_REGION: 'Tuvasta tekst ristküliku alal',
        PDFVIEWER_REGION_OCR_FAILED: 'Nutikas tuvastamine ebaõnnestus. Proovige uuesti.',
        PDFVIEWER_REGION_OCR_EMPTY: 'Sellel alal teksti ei tuvastatud.',
        PDFVIEWER_REGION_OCR_PAGE_NOT_READY: 'Lehekülje pilt pole veel valmis. Oodake laadimist ja proovige uuesti.',
        PDFVIEWER_SETTINGS_TOOL_COUNT_MISMATCH: 'Faili ei saa laadida. Ettevõtte tööriistad ei ühti seadistuste failiga.',
        REVISION_REQUIRED: 'Revisjon peab olema sisestatud, kui PDF failil puuduvad seadistused.',

        // PDF Report strings
        PDF_REPORT_TITLE: 'Mõõteraport',
        PDF_REPORT_ORDER: 'Tellimus :',
        PDF_REPORT_DETAIL: 'Detail :',
        PDF_REPORT_REVISION_LABEL: 'Rev nr.',
        PDF_REPORT_MEASURED_DETAIL_NUMBER: 'Raporti nr.',
        PDF_REPORT_MEASURABLE_DETAIL_NUMBER: 'Mõõdetud detaili nr.',
        PDF_REPORT_MEASURER: 'Mõõtis :',
        PDF_REPORT_TIME: 'Aeg :',
        // PDF Report table headers
        PDF_REPORT_TABLE_M_NR: 'Pos nr',
        PDF_REPORT_TABLE_NOMINAL_DIM: 'Nimimõõt',
        PDF_REPORT_TABLE_TOLERANCE: 'Tolerants',
        PDF_REPORT_TABLE_MIN: 'Min',
        PDF_REPORT_TABLE_MAX: 'Max',
        PDF_REPORT_TABLE_MEASURED: 'Mõõdetud',
        PDF_REPORT_TABLE_TOOL: 'Instr.',
        PDF_REPORT_TABLE_RESULT: 'Tulemus',
        PDF_REPORT_TABLE_TIME: 'Aeg',
        PDF_REPORT_TOOLS_TABLE_TITLE: 'Kasutatud tööriistad',
        PDF_REPORT_TOOLS_TABLE_NUMBER: 'Nr',
        PDF_REPORT_TOOLS_TABLE_NAME: 'Nimi',
        PDF_REPORT_TOOLS_TABLE_PRECISION_CLASS: 'Täpsusklass',
        PDF_REPORT_TOOLS_TABLE_PICTURE: 'Pilt',
        PDF_REPORT_YES: 'Jah',
        PDF_REPORT_NO: 'Ei',
    },
    en: {
        // App title
        APP_TITLE: 'QUALITY DATUM',
        NO_ORGANIZATION_MESSAGE: 'Contact your manager.',
        NO_TOOLS_MESSAGE: 'No measurement tools available. Please contact your manager to add measurement tools.',
        SUBSCRIPTION_INACTIVE_TITLE: 'Subscription is not active',
        SUBSCRIPTION_INACTIVE_MESSAGE: 'Your subscription has expired or been cancelled. Please resubscribe on the profile page to continue managing users and editors. Users and editors cannot work until you resubscribe.',
        SUBSCRIPTION_INACTIVE_ERROR_ADD: 'Subscription is not active. Please resubscribe on the profile page to add users.',
        SUBSCRIPTION_INACTIVE_ERROR_ROLE: 'Subscription is not active. Please resubscribe on the profile page to change user roles.',

        // Roles
        OPERATOR: 'Operator',
        ENGINEER: 'Engineer',

        // Form labels
        DETAIL_NUMBER: 'Detail No. *',
        ORDER_NUMBER: 'Order No. *',
        MEASURED_DETAIL_NUMBER: 'Measurement Report Number *',
        REVISION_LABEL: 'Revision *',

        // Buttons
        SELECT_NEW: 'SELECT NEW',
        SELECT: 'SELECT',
        CONTINUE: 'CONTINUE',

        // File types
        PDF: 'PDF',
        XLSX: 'XLSX',

        // Error messages
        INVALID_PDF_FILE: 'The imported file is not valid. Please select a PDF file.',
        INVALID_EXCEL_FILE: 'The imported file is not valid. Please select an Excel file.',

        // Icons/symbols
        ARROW: '→',
        FILE_ICON: '📄',

        // PDF Viewer strings
        BACK_BUTTON: 'Back',
        SAVE_BUTTON: 'Save',
        ORDER_NUMBER_LABEL: 'Order No:',
        EDITOR_SAVE_ORDER_NUMBER_DIALOG_TITLE: 'Enter order number',
        EDITOR_SAVE_PDF_MEASURED_DETAIL_LABEL: 'Measured detail number:',
        ENGINEER_NAME_LABEL: 'Engineer Name:',
        ENGINEER_NAME: 'Vasja Pupkin',
        DETAIL_NUMBER_LABEL: 'Detail No:',
        MEASURED_DETAIL_NUMBER_LABEL: 'Measurement Report No:',

        // Loading states
        LOADING: 'Loading...',

        // PDF loading states
        PDF_LOADING: 'Loading PDF file...',
        PDF_ERROR: 'Failed to load PDF file.',
        PDF_NOT_SELECTED: 'No PDF file selected.',
        NO_PDF_FILE_SELECTED: 'No PDF file selected.',

        G2_RECOGNIZED_LABEL: 'Recognized standard:',
        ISO22081_LINEAR_SIZES: 'Linear sizes',
        ISO22081_RADIUS_CHAMFER_SIZES: 'Radius & chamfer (R, C)',
        ISO22081_SHAPE_SIZES: 'Shape sizes',
        ISO22081_ANGULAR_SIZES: 'Angular sizes',

        HELP_BUTTON_TITLE: 'Keyboard shortcuts',
        HELP_MENU_TITLE: 'Keyboard shortcuts',
        HELP_ENTER: 'Save / confirm',
        HELP_F2: 'Save / confirm',
        HELP_F1: 'Save / confirm',
        HELP_DELETE: 'Delete rectangle',
        HELP_F4: 'Delete rectangle',
        HELP_ESCAPE: 'Close menu / delete unsubmitted rectangle',
        HELP_ESCAPE_USER: 'Close menu',
        HELP_TOOL_SELECT: 'Select tool',
        HELP_PLUS: 'Select OK',
        HELP_MINUS: 'Select No',
        HELP_CLOSE: 'Close',

        SETTINGS_BUTTON_TITLE: 'Settings',
        SETTINGS_MENU_TITLE: 'PDF settings',
        SETTINGS_SEQUENCE_MEASUREMENT: 'Sequence measurement',
        SETTINGS_EXAM_MODE: 'Exam',
        EXAM_SELECT_TOOL: 'Select tool',
        EXAM_TOOL_CORRECT: 'Correct tool',
        EXAM_TOOL_INCORRECT: 'Wrong tool',
        SETTINGS_DOWNLOAD_PATH: 'Reports folder',
        SETTINGS_SETTINGS_PDF_PATH: 'Settings folder',
        SETTINGS_CHOOSE_FOLDER: 'Choose folder',
        SETTINGS_CLEAR_FOLDER: 'Clear',
        SETTINGS_FOLDER_NOT_SELECTED: 'Folder not selected',
        SETTINGS_APPLY: 'Apply',
        SAVE_SUCCESS_TITLE: 'Saved successfully!',
        SAVE_SUCCESS_TITLE_LOCAL_SERVER: 'Saved to your company local server!',
        SAVE_SUCCESS_PATH: 'File: {fileName}\nFolder: {folderName}',
        SAVE_SUCCESS_DEFAULT_FOLDER: 'Browser default download folder',
        SAVE_SUCCESS_FILE_LABEL: 'File',
        SAVE_SUCCESS_FOLDER_LABEL: 'Folder',
        SAVE_SUCCESS_OPEN_PDF: 'Open PDF',
        SAVE_SUCCESS_OK: 'OK',

        // Pagination
        PREVIOUS_PAGE: 'Previous',
        NEXT_PAGE: 'Next',
        PAGE_LABEL: 'Page',
        PAGE: 'Page',

        // Context menu and inputs
        MEASUREMENT_TOOL_PLACEHOLDER: '...',
        TOOL_NUMBER_PLACEHOLDER: '...',
        NOMINAL_DIMENSION_LABEL: 'Nominal dimension',
        NOMINAL_DIMENSION_PLACEHOLDER: '...',
        DESCRIPTION_LABEL: 'Description',
        TOLERANCE_PLUS_LABEL: '+',
        TOLERANCE_MINUS_LABEL: '-',
        TOLERANCE_PLUS_PLACEHOLDER: '...',
        TOLERANCE_MINUS_PLACEHOLDER: '...',
        MEASUREMENT_RESULT_PLACEHOLDER: '0.00',

        // Tolerance buttons
        SMALL_TOLERANCE_BUTTON: '+ -',
        MEDIUM_TOLERANCE_BUTTON: '+ +',
        LARGE_TOLERANCE_BUTTON: '- -',

        // Excel export headers
        MEASUREMENT_NUMBER: 'Measurement',
        TOOL: 'Tool',
        NOMINAL_DIMENSION: 'Nominal Dimension',
        MEASUREMENT_RESULT: 'Measurement Result',
        RESULT: 'Result',
        MEASURED_DETAIL_NUMBER_EXPORT: 'Measurement Report Number',
        COMPLETED: 'Completed?',
        TOLERANCE_PLUS: 'Upper tolerance',
        TOLERANCE_MINUS: 'Lower tolerance',
        TOLERANCE_TYPE: 'Tolerance Type',
        TIME: 'Time',
        X_POSITION: 'X Position',
        Y_POSITION: 'Y Position',
        WIDTH: 'Width',
        HEIGHT: 'Height',
        DETAIL_NUMBER_EXPORT: 'Detail Number',

        // Boolean values
        YES: 'Yes',
        NO: 'No',

        // File names
        UNKNOWN: 'unknown',
        SETUP_DATA_SHEET: 'Setup Data',
        USER_REPORT_DATA_SHEET: 'Measurements',

        // Error messages
        ROLE_SELECTION_ERROR: 'Role must be selected. Please choose either operator or engineer.',

        // Measurement tools
        CALIPER: 'Caliper',
        CALIBER_TOOL: 'Caliper',
        MICROMETER: 'Micrometer',
        DIGITAL_INSIDE_MICROMETER: 'Inside Micrometer',
        DIAL_INDICATOR: 'Dial Indicator',
        STOPWATCH: 'Dial Indicator',
        HEIGHT_GAUGE: 'Height Gauge',
        HEIGHT_MEASURING_JACK: 'Height Gauge',
        THREAD_GAUGE: 'Thread Gauge',
        SCREW_DRIVER: 'Thread Gauge',
        TOOL_7: 'NO-GO Thread Ring Gauge',
        TOOL_8: 'GO Thread Ring Gauge',
        TOOL_9: '3-Point Inside Bore Micrometer',
        TOOL_10: 'Depth Micrometer',
        TOOL_11: 'Pin Gauge',
        MULTIMETER: 'Multimeter',

        // Registration page
        USERNAME_LABEL: 'Username',
        USERNAME_PLACEHOLDER: 'Enter username',
        EMAIL_LABEL: 'Email',
        EMAIL_PLACEHOLDER: 'Enter email address',
        PASSWORD_LABEL: 'Password',
        PASSWORD_PLACEHOLDER: 'Enter password',
        CONFIRM_PASSWORD_LABEL: 'Confirm password',
        CONFIRM_PASSWORD_PLACEHOLDER: 'Confirm password',
        ORGANIZATION_LABEL: 'Company',
        ORGANIZATION_PLACEHOLDER: 'Enter company name, be short',
        ORGANIZATION_IMAGE_LABEL: 'Logo ( PNG or JPEG )',
        ORGANIZATION_LOGO_REQUIRED_ERROR: 'Company logo is required (PNG or JPEG).',
        ORGANIZATION_LOGO_FORMAT_ERROR: 'Company logo must be in PNG or JPEG format.',
        ORGANIZATION_LOGO_PREVIEW: 'Organization logo preview',
        USE_DEFAULT_LOGO_LABEL: 'Use default',
        OR_LABEL: 'or',
        ROLE_LABEL: 'Role',
        SELECT_ROLE_PLACEHOLDER: 'Select role',
        ROLE1: 'Manager',
        ROLE2: 'User',

        // Pricing plans
        PRICING_PLANS_TITLE: 'Choose Plan',
        YOUR_PLAN_TITLE: 'Your Plan',
        BASIC_PLAN_TITLE: 'Basic',
        PREMIUM_PLAN_TITLE: 'Premium',
        ULTIMATE_PLAN_TITLE: 'Ultimate',
        MONTHLY_PRICE: 'EUR/month',
        EDITORS_LABEL: 'editors',
        USERS_LABEL: 'users',
        MEASUREMENT_TOOLS_LABEL: 'measurement tools',
        ADDITIONAL_TOOLS_LABEL: 'additional measurement tools',
        ADDITIONAL_TOOL_PRICE: 'EUR/month each additional tool',
        UNLIMITED_LABEL: 'unlimited',
        SELECT_PLAN_BUTTON: 'Select Plan',
        PLAN_ACTIVATED_BUTTON: 'Active',
        CONTACT_US_BUTTON: 'Send request',
        PLAN_DOWNGRADE_WARNING_TITLE: 'Warning: Plan Change',
        PLAN_DOWNGRADE_WARNING_MESSAGE: 'If you change to a cheaper plan, all your users and editors will be deleted. This action is irreversible. Do you want to continue?',
        PLAN_DOWNGRADE_CONFIRM_BUTTON: 'Continue',
        PLAN_DOWNGRADE_CANCEL_BUTTON: 'Cancel',

        REGISTER_BUTTON: 'Register',
        REGISTERING_BUTTON: 'Registering...',
        PASSWORDS_DONT_MATCH_ERROR: 'Passwords do not match',
        PASSWORD_TOO_SHORT_ERROR: 'Password must be at least 8 characters long',
        PASSWORD_TOO_LONG_ERROR: 'Password must not be longer than 128 characters',
        PASSWORD_MISSING_UPPERCASE_ERROR: 'Password must contain at least one uppercase letter (A-Z)',
        PASSWORD_MISSING_LOWERCASE_ERROR: 'Password must contain at least one lowercase letter (a-z)',
        PASSWORD_MISSING_DIGIT_ERROR: 'Password must contain at least one digit (0-9)',
        PASSWORD_MISSING_SPECIAL_CHAR_ERROR: 'Password must contain at least one special character (!@#$%^&*()_+-=[]{}|;:,.<>?)',
        PASSWORD_REPEATED_CHARS_ERROR: 'Password must not contain repeated characters in sequence',
        PASSWORD_COMMON_SEQUENCE_ERROR: 'Password must not contain common sequences (123, abc, qwe, etc.)',
        FILL_ALL_FIELDS_ERROR: 'Please fill in all fields',
        REGISTRATION_ERROR: 'Registration error occurred',
        REGISTRATION_SUCCESS: 'Registration successful!',
        REGISTRATION_RATE_LIMIT_ERROR: 'Too many registration attempts. Please try again later.',
        REGISTRATION_RATE_LIMIT_MESSAGE: 'Please wait before trying again',

        // Payment Error Messages
        PAYMENT_ERROR: 'Payment error',
        PAYMENT_CANCELLED: 'Payment cancelled',
        PAYMENT_FAILED: 'Payment failed',
        PAYMENT_PROCESSING_ERROR: 'Payment processing error',
        PAYMENT_SESSION_EXPIRED: 'Payment session expired',
        PAYMENT_NOT_COMPLETED: 'Payment not completed',
        PROCESSING_PAYMENT: 'Processing payment...',
        PLEASE_WAIT: 'Please wait',

        // Password re-entry after payment (security feature)
        PAYMENT_SUCCESS_ENTER_PASSWORD_TITLE: 'Payment Successful',
        PAYMENT_SUCCESS_ENTER_PASSWORD_DESC: 'For security, please enter your password to complete registration.',
        COMPLETE_REGISTRATION_BUTTON: 'Complete Registration',

        // Firebase Auth Error Messages
        FIREBASE_EMAIL_ALREADY_IN_USE: 'This email address is already in use',
        FIREBASE_INVALID_EMAIL: 'Invalid email address',
        FIREBASE_OPERATION_NOT_ALLOWED: 'This operation is not allowed',
        FIREBASE_WEAK_PASSWORD: 'Password is too weak',
        FIREBASE_USER_DISABLED: 'This user is disabled',
        FIREBASE_USER_NOT_FOUND: 'User not found',
        FIREBASE_WRONG_PASSWORD: 'Wrong password',
        FIREBASE_INVALID_CREDENTIAL: 'Wrong username or password',
        FIREBASE_TOO_MANY_REQUESTS: 'Too many failed attempts. Please try again later',
        FIREBASE_NETWORK_REQUEST_FAILED: 'Network error. Please check your internet connection',
        FIREBASE_REQUIRES_RECENT_LOGIN: 'This operation requires recent login',

        // Login page
        LOGIN_EMAIL_LABEL: 'Email',
        LOGIN_EMAIL_PLACEHOLDER: 'Enter email address',
        LOGIN_PASSWORD_LABEL: 'Password',
        LOGIN_PASSWORD_PLACEHOLDER: 'Enter password',
        LOGIN_BUTTON: 'Log In',
        LOGIN_LOADING: 'Logging in...',
        LOGIN_ERROR: 'Login error occurred',
        LOGIN_FILL_FIELDS_ERROR: 'Please enter email address and password',
        FORGOT_PASSWORD_BUTTON: 'Forgot password?',
        FORGOT_PASSWORD_ALERT: 'Password recovery feature coming soon!',
        RESET_PASSWORD_TITLE: 'Reset Password',
        RESET_PASSWORD_EMAIL_LABEL: 'Email Address',
        RESET_PASSWORD_EMAIL_PLACEHOLDER: 'Enter your email address',
        RESET_PASSWORD_EMAIL_REQUIRED: 'Please enter email address',
        RESET_PASSWORD_ERROR: 'Error resetting password',
        RESET_PASSWORD_SUCCESS: 'Password reset link has been sent to your email address.',
        RESET_PASSWORD_INSTRUCTIONS: 'Please check your email and follow the instructions to reset your password.',
        RESET_PASSWORD_CANCEL: 'Cancel',
        RESET_PASSWORD_SENDING: 'Sending...',
        RESET_PASSWORD_SEND: 'Send',

        // Contact Us page
        CONTACT_US_TITLE: 'Contact Us',
        CONTACT_US_SUBTITLE: 'For Ultimate Plan',
        CONTACT_US_DESCRIPTION: 'If you want to discuss our product or get a quote for personal version, fill out the form.',
        NAME_LABEL: 'Name',
        NAME_PLACEHOLDER: 'Enter your name',
        COMPANY_LABEL: 'Company',
        COMPANY_PLACEHOLDER: 'Enter company name',
        PHONE_LABEL: 'Phone',
        PHONE_PLACEHOLDER: 'Enter phone number',
        MESSAGE_LABEL: 'Message',
        MESSAGE_PLACEHOLDER: 'Describe your needs and questions...',
        SEND_MESSAGE_BUTTON: 'Send Message',
        SENDING_MESSAGE_BUTTON: 'Sending...',
        MESSAGE_SENT_SUCCESS: 'Message sent successfully!',
        MESSAGE_SENT_ERROR: 'Error sending message',
        REQUIRED_FIELD_ERROR: 'This field is required',
        INVALID_EMAIL_ERROR: 'Please enter a valid email address',
        INVALID_PHONE_ERROR: 'Please enter a valid phone number',

        // No Connection Page
        NO_CONNECTION_TITLE: 'No Connection',
        NO_CONNECTION_DESCRIPTION: 'Internet connection is required for the application to work properly. Please check your internet connection and try again.',
        NO_CONNECTION_TIPS_TITLE: 'Check the following:',
        NO_CONNECTION_TIP_1: 'Internet connection availability',
        NO_CONNECTION_TIP_2: 'Wi-Fi or mobile data settings',
        NO_CONNECTION_TIP_3: 'Network strength',
        NO_CONNECTION_TIP_4: 'Firewall or security settings',
        RETRY_BUTTON: 'Try Again',

        // Profile Page
        PROFILE_TITLE: 'My Profile',
        PROFILE_NAME_LABEL: 'Name',
        PROFILE_EMAIL_LABEL: 'Email Address',
        PROFILE_EMAIL_VERIFIED_LABEL: 'Email Verified',
        PROFILE_LANGUAGE_LABEL: 'App language',
        PROFILE_REPORT_LANGUAGE_LABEL: 'Report Language',
        PROFILE_LANGUAGE_ET: 'Estonian',
        PROFILE_LANGUAGE_EN: 'English',
        PROFILE_LANGUAGE_RU: 'Russian',
        PROFILE_ROLE_LABEL: 'Role',
        PROFILE_ORGANIZATION_LABEL: 'Organization',
        PROFILE_ORGANIZATION_PLACEHOLDER: 'Enter organization name',
        PROFILE_SUBSCRIPTION_PLAN_LABEL: 'Subscription Plan',
        PROFILE_EDITOR_LIMIT_LABEL: 'Editor Limit',
        PROFILE_USER_LIMIT_LABEL: 'User Limit',
        PROFILE_SAVE_ORGANIZATION: 'Save Organization',
        PROFILE_SAVING: 'Saving...',
        PROFILE_SAVE: 'Save',
        PROFILE_LOGO_LABEL: 'Logo',
        PROFILE_LOGO_CHANGE: 'Change logo',
        PROFILE_LOGO_USE_DEFAULT: 'Use default logo',
        PROFILE_LOGO_SELECT_FILE: 'Select file',
        PROFILE_LOGO_ERROR_NO_FILE: 'Please select an image file',
        PROFILE_LOGO_ERROR_UPLOAD: 'Error saving logo',
        PROFILE_PDF_WORKFLOW_LABEL: 'How operators and editors use PDFs',
        PROFILE_PDF_WORKFLOW_MANUAL: 'Manual file selection',
        PROFILE_PDF_WORKFLOW_LOCAL_SERVER: 'Local server',
        PROFILE_PDF_WORKFLOW_CLOUD_DB: 'Cloud DB',
        PROFILE_PDF_WORKFLOW_CLOUD_DB_HELP:
            'Reports and settings are saved to the cloud (Firebase).',
        SAVE_SUCCESS_TITLE_CLOUD_DB: 'Saved to cloud!',
        PROFILE_PDF_WORKFLOW_MANUAL_HELP:
            'Editors and operators choose PDF files manually.',
        LOCAL_SERVER_URL_LABEL: 'Local server URL',
        LOCAL_SERVER_ENABLED_LABEL: 'Enabled (operators use this server)',
        LOCAL_SERVER_LAST_SEEN: 'Last seen: ',
        LOCAL_SERVER_VERSION_PREFIX: ' (version ',
        LOCAL_SERVER_NEVER_SEEN: 'Server has not reported in yet',
        LOCAL_SERVER_COMPANY_ID_LABEL: 'Company ID (local server setup)',
        LOCAL_SERVER_COMPANY_ID_HINT:
            'IT enters this exact value in the setup wizard’s Company ID field. They can also open http://SERVER_IP:8765/setup?companyId=PASTE_ID_HERE — SERVER_IP is this server’s LAN address — so only token and LAN IP stay to fill manually.',
        LOCAL_SERVER_TOKEN_LABEL: 'Registration token',
        LOCAL_SERVER_TOKEN_BTN: 'Issue registration token',
        LOCAL_SERVER_TOKEN_BTN_LOADING: 'Issuing...',
        LOCAL_SERVER_TOKEN_HINT: 'Hand the token to the IT engineer who installs the local server. Single-use, valid for 24 hours.',
        LOCAL_SERVER_TOKEN_EXPIRES_AT: 'Expires at: ',
        LOCAL_SERVER_TOKEN_COPY: 'Copy',
        LOCAL_SERVER_TOKEN_COPIED: 'Copied',
        LOCAL_SERVER_TOKEN_ERROR: 'Failed to issue token',
        LOCAL_SERVER_SAVED: 'Saved',
        LOCAL_SERVER_SAVE_ERROR: 'Failed to save local server settings',
        LOCAL_SERVER_INVALID_URL: 'URL must start with https:// or http://',
        LOCAL_SERVER_PUBLISH_FAILED: 'Saved locally, but failed to publish revision to local server: ',
        LOCAL_SERVER_NO_REVISIONS: 'No published revisions for this detail',
        HOME_EDITOR_REVISION_UPLOAD_NEW: 'New revision — upload PDF',
        HOME_EDITOR_REVISION_ALREADY_EXISTS: 'Revision with this number already exists',
        LOCAL_SERVER_REPORT_UPLOAD_FAILED: 'Local server save failed. ',
        LOCAL_SERVER_SAVE_FAILED_MODAL_TITLE: 'Could not save to the server',
        REPORTS_NAV_BTN: 'Reports',
        REPORTS_TITLE: 'Reports',
        REPORTS_FILTER_DETAIL: 'Detail nr',
        REPORTS_FILTER_ORDER: 'Order nr',
        REPORTS_FILTER_OPERATOR: 'Operator UID',
        REPORTS_APPLY_FILTERS: 'Apply',
        REPORTS_RESET_FILTERS: 'Reset',
        REPORTS_EMPTY: 'No reports found',
        REPORTS_TYPE_TO_SEARCH: 'Start typing in the search field above to find reports.',
        REPORTS_NEED_LOGIN: 'Please sign in to view reports.',
        REPORTS_NO_LOCAL_SERVER: 'Reports are stored on your company\'s local server. Ask your manager to configure it in profile settings.',
        REPORTS_COL_DATE: 'Date',
        REPORTS_COL_DETAIL: 'Detail',
        REPORTS_COL_REVISION: 'Revision',
        REPORTS_COL_ORDER: 'Order',
        REPORTS_COL_MEAS_NR: 'Meas. nr',
        REPORTS_COL_OPERATOR: 'Operator',
        REPORTS_COL_SIZE: 'Size',
        REPORTS_COL_ACTION: 'Action',
        REPORTS_OPEN_REPORT_PDF: 'Open report PDF in a new tab',
        REPORTS_OPEN_PDF_POPUP_BLOCKED: 'Could not open PDF: the browser blocked the new window. Allow pop-ups for this site.',
        REPORTS_DOWNLOAD_REPORT_PDF: 'Download report PDF',
        REPORTS_DELETE_CONFIRM_TITLE: 'Confirm report deletion',
        REPORTS_DELETE_CONFIRM_LOCAL: 'Permanently delete this report from the local server?',
        REPORTS_DELETE_CONFIRM_CLOUD: 'Permanently delete this report from Cloud DB?',
        REPORTS_PREV: 'Prev',
        REPORTS_NEXT: 'Next',
        REPORTS_PAGE_INFO_FORMAT: '{from}–{to} of {total}',
        REPORTS_LOADING: 'Loading…',
        SAVED_SETTINGS_TITLE: 'Settings',
        SAVED_SETTINGS_TYPE_TO_SEARCH: 'Start typing in the search field below to find saved revision PDFs.',
        SAVED_SETTINGS_EMPTY: 'No matches',
        SAVED_SETTINGS_OPEN_PDF: 'Open settings PDF in a new tab',
        SAVED_SETTINGS_EDIT: 'Edit',
        SAVED_SETTINGS_COL_STATUS: 'Status',
        SAVED_SETTINGS_COL_EDITOR: 'Author',
        SAVED_SETTINGS_DELETE_CONFIRM_TITLE: 'Confirm saved settings deletion',
        SAVED_SETTINGS_DELETE_CONFIRM_LOCAL: 'Permanently delete this saved settings record from the local server?',
        SAVED_SETTINGS_DELETE_CONFIRM_CLOUD: 'Permanently delete this saved settings record from Cloud DB?',
        PROFILE_LOGOUT: 'Log Out',
        PROFILE_DELETE_PROFILE: 'Delete Profile',
        PROFILE_DELETING: 'Deleting...',
        PROFILE_DELETE_CONFIRM_TITLE: 'Delete Profile',
        PROFILE_DELETE_CONFIRM_MESSAGE: 'Are you sure you want to delete your profile? This action is irreversible and all your data will be permanently deleted.',
        PROFILE_DELETE_WARNING: 'Warning: You cannot undo this action.',
        PROFILE_PASSWORD_CONFIRM_LABEL: 'Password for Confirmation',
        PROFILE_PASSWORD_PLACEHOLDER: 'Enter your password',
        PROFILE_CANCEL: 'Cancel',
        PROFILE_DELETE: 'Delete',
        PROFILE_LOADING_FAILED: 'Failed to load profile',
        PROFILE_BACK: 'Back',
        PROFILE_PROCESSING_PAYMENT: 'Processing Payment...',
        PROFILE_LOADING: 'Loading...',
        PROFILE_PASSWORD_REQUIRED: 'Please enter password',
        PROFILE_WRONG_PASSWORD: 'Wrong password',
        PROFILE_RELOGIN_REQUIRED: 'Please log in again and try again',
        PROFILE_DELETE_ERROR: 'Error deleting profile',
        PROFILE_CHANGE_PASSWORD: 'Change Password',
        PROFILE_CHANGE_PASSWORD_TITLE: 'Change Password',
        PROFILE_CHANGE_PASSWORD_MESSAGE: 'Enter your current password and new password',
        PROFILE_CURRENT_PASSWORD_LABEL: 'Current Password',
        PROFILE_NEW_PASSWORD_LABEL: 'New Password',
        PROFILE_CONFIRM_NEW_PASSWORD_LABEL: 'Confirm New Password',
        PROFILE_CURRENT_PASSWORD_PLACEHOLDER: 'Enter current password',
        PROFILE_NEW_PASSWORD_PLACEHOLDER: 'Enter new password',
        PROFILE_CONFIRM_NEW_PASSWORD_PLACEHOLDER: 'Confirm new password',
        PROFILE_CHANGING_PASSWORD: 'Changing password...',
        PROFILE_PASSWORD_CHANGED: 'Password changed successfully',
        PROFILE_PASSWORD_CHANGE_ERROR: 'Error changing password',
        PROFILE_PASSWORD_MISMATCH: 'New passwords do not match',
        PROFILE_NEW_PASSWORD_REQUIRED: 'Please enter new password',
        PROFILE_CONFIRM_PASSWORD_REQUIRED: 'Please confirm new password',
        PROFILE_ORGANIZATION_SAVE_ERROR: 'Error saving organization',
        PROFILE_REMOVE_TOOLS_ERROR: 'Error removing tools',
        PROFILE_UNKNOWN_ERROR: 'Unknown error',
        CHECKOUT_SESSION_ERROR: 'Failed to create checkout session',
        ERROR_OCCURRED: 'An error occurred',
        ERROR_REMOVING_MEMBERS: 'Error removing company members',

        // Roles
        ROLE_ADMIN: 'Administrator',
        ROLE_MANAGER: 'Manager',
        ROLE_EDITOR: 'Editor',
        ROLE_USER: 'User',

        // Remove Tools Section
        REMOVE_TOOLS_TITLE: 'Delete Tools',
        REMOVE_TOOLS_DESCRIPTION: 'Deletes all tools if you need to change or delete unused tools.',
        REMOVE_TOOLS_CONFIRM_TITLE: 'Confirm Tool Deletion',
        REMOVE_TOOLS_CONFIRM_MESSAGE: 'Are you sure you want to delete all tools? This action will cost 10 EUR and will delete all tools (including custom tools and their images).',
        REMOVE_TOOLS_CONFIRM: 'Confirm',
        REMOVE_TOOLS_PROCESSING: 'Processing...',

        // Add Tool Confirmation
        ADD_TOOL_CONFIRM_TITLE: 'Add Tool',
        ADD_TOOL_CONFIRM_MESSAGE: 'Are you sure you want to add this tool? After adding, you can only delete or change it for an additional fee. More information in profile settings.',
        ADD_TOOL_WARNING: 'Warning: You cannot undo this action for free.',
        ADD_TOOL_CONFIRM: 'Confirm',

        // Dashboard Page
        DASHBOARD_ENTER_EMAIL: 'Please enter email address',
        DASHBOARD_ENTER_EMAIL_PLACEHOLDER: 'Enter email address and press Add...',
        DASHBOARD_PREVIEW: 'Preview',
        DASHBOARD_INVALID_EMAIL: 'Invalid email address',
        DASHBOARD_USER_NOT_LOGGED_IN: 'User is not logged in',
        DASHBOARD_ADD_EMAIL_ERROR: 'Error adding email.',
        DASHBOARD_USER_ALREADY_IN_COMPANY: 'This user is already in the company',
        DASHBOARD_ADD_USER_ERROR: 'Error adding user',
        DASHBOARD_USER_ADDED_SUCCESS: 'User added to company',
        DASHBOARD_UPDATE_ROLE_ERROR: 'Error updating role',
        DASHBOARD_REMOVE_USER_ERROR: 'Error removing user',
        DASHBOARD_EDITOR_LIMIT_REACHED: 'Editor limit reached',
        DASHBOARD_USER_LIMIT_REACHED: 'User limit reached',
        DASHBOARD_TOOL_LIMIT_REACHED: 'Tool limit reached',
        DASHBOARD_ADD_TOOL_ERROR: 'Error adding tool',
        DASHBOARD_REMOVE_TOOL_ERROR: 'Error removing tool',
        DASHBOARD_DELETE_TOOL: 'Delete Tool',
        DASHBOARD_DELETE_TOOL_CONFIRM_TITLE: 'Confirm Tool Deletion',
        DASHBOARD_DELETE_TOOL_CONFIRM_MESSAGE: 'Are you sure you want to delete the tool',
        DASHBOARD_DELETE_TOOL_WARNING: 'This action will cost 1 EUR + tax and will permanently delete this tool (including custom tool images if applicable).',
        DASHBOARD_DELETE_TOOL_CONFIRM: 'Confirm & Pay',
        DASHBOARD_PROCESSING: 'Processing...',
        DASHBOARD_TOOL_NAME_REQUIRED: 'Please enter tool name',
        DASHBOARD_ADD_CUSTOM_TOOL_ERROR: 'Error adding custom tool',
        DASHBOARD_SELECT_IMAGE_FILE: 'Please select image file',
        DASHBOARD_SELECT_FILE: 'Choose file',
        DASHBOARD_SAVE: 'Save',
        DASHBOARD_DELETE: 'Delete',
        DASHBOARD_CANCEL: 'Cancel',
        DASHBOARD_EXIT: 'Log Out',
        DASHBOARD_ADD_TOOL: 'Add Tool',
        DASHBOARD_ADD_CUSTOM_TOOL: 'Add Custom Tool',
        DASHBOARD_SAVING: 'Saving...',
        DASHBOARD_ADD: 'Add',
        DASHBOARD_SENDING: 'Sending...',
        DASHBOARD_ADD_CUSTOM_TOOL_TITLE: 'Add Custom Tool',
        DASHBOARD_CUSTOM_TOOL_NAME_LABEL: 'Tool Name *',
        DASHBOARD_CUSTOM_TOOL_NAME_PLACEHOLDER: 'Enter tool name',
        DASHBOARD_CUSTOM_TOOL_COLOR_LABEL: 'Color *',
        DASHBOARD_SELECT_COLOR: 'Select color',
        DASHBOARD_TOOL_COLOR_REQUIRED: 'Color is required',
        DASHBOARD_IMAGE_FILE_LABEL: 'Image File *',
        DASHBOARD_IMAGE_FILE_NOTE: 'For better UI in app choose image without background. Image should be in landscape orientation',
        DASHBOARD_IMAGE_FILE_HELP: 'Supported formats: PNG, JPEG, GIF, WebP. Maximum size: 5MB',
        DASHBOARD_PRECISION_CLASS_LABEL: 'Precision Class *',
        DASHBOARD_PRECISION_CLASS_PLACEHOLDER: 'Enter precision class',
        DASHBOARD_PRECISION_CLASS_REQUIRED: 'Precision class is required',
        DASHBOARD_PRECISION_CLASS_HELP: 'Do not enter +- values.\nExample : entered 0.01, user must enter min. 2 numbers after coma.',
        DASHBOARD_TOOL_WITHOUT_MEASUREMENT: 'Tool without measurement',
        DASHBOARD_TOOL_WITHOUT_MEASUREMENT_DESCRIPTION: 'Activate, if Your tool have fixed size',
        DASHBOARD_MINIMUM_PRECISION_LABEL: 'Minimum number precision',
        DASHBOARD_MINIMUM_PRECISION_HELP: 'Minimum value precision that must enter user to submit measurement.',
        DASHBOARD_TOOL_IMAGE_REQUIRED: 'Image file is required',
        DASHBOARD_IMAGE_TOO_LARGE: 'Image file is too large (maximum 5MB)',
        DASHBOARD_EDITORS_LABEL: 'Editors:',
        DASHBOARD_USERS_LABEL: 'Users:',
        DASHBOARD_TOOLS_LABEL: 'Tools:',
        DASHBOARD_MEMBERS_TITLE: 'Company Members',
        DASHBOARD_TOOLS_TITLE: 'Tools',
        DASHBOARD_USER_ROLE: 'User',
        DASHBOARD_EDITOR_ROLE: 'Editor',
        DASHBOARD_NO_MEMBERS: 'No members in company yet',
        DASHBOARD_ALL_TOOLS_ADDED: 'All tools are already added',
        DASHBOARD_CONFIRM_DELETE_TITLE: 'Confirm Deletion',
        DASHBOARD_CONFIRM_DELETE_MESSAGE: 'Are you sure you want to remove user',
        DASHBOARD_DELETE_WARNING: 'This action cannot be undone.',
        DASHBOARD_LOADING: 'Loading...',

        // Home Page
        HOME_EXCEL_ERROR: 'Error processing Excel file',
        HOME_DELETE_FILE: 'Delete File',
        PDF_NO_EMBEDDED_SETTINGS: 'PDF file does not contain settings. Select a file with embedded settings.',
        PDF_SETTINGS_EXTRACTED: 'Settings found',
        SAVE_PDF_WITH_SETTINGS: 'Save PDF with settings',

        // PdfViewer
        PDFVIEWER_NO_TOOLS_MESSAGE: 'No tools available. Please contact your manager.',
        PDFVIEWER_TOOL_NUMBER_RANGE: 'Please enter a number between 1 and',
        PDFVIEWER_MAX_TOOL_NUMBER: 'Maximum number is',
        PDFVIEWER_MIN_TOOL_NUMBER: 'Number must be at least 1',
        PDFVIEWER_HOLE_SHAFT_REQUIRED: 'Shaft and Hole must be selected in dropdown',
        PDFVIEWER_HOLE_SHAFT_STANDARD_REQUIRED: 'If ISO 286 needed, select shaft and hole in left corner...',
        PDFVIEWER_LOADING: 'Loading...',
        PDFVIEWER_RECOGNIZE_REGION: 'Recognize text in rectangle',
        PDFVIEWER_REGION_OCR_FAILED: 'Smart recognition failed. Please try again.',
        PDFVIEWER_REGION_OCR_EMPTY: 'No text was recognized in this area.',
        PDFVIEWER_REGION_OCR_PAGE_NOT_READY: 'Page image is not ready yet. Wait for it to load, then try again.',
        PDFVIEWER_SETTINGS_TOOL_COUNT_MISMATCH: 'Can\'t load file. Company tools doesn\'t match with settings file.',
        REVISION_REQUIRED: 'Revision must be set when PDF file has no embedded settings.',

        // PDF Report strings
        PDF_REPORT_TITLE: 'Measurement Report',
        PDF_REPORT_ORDER: 'Order :',
        PDF_REPORT_DETAIL: 'Detail :',
        PDF_REPORT_REVISION_LABEL: 'Rev nr.',
        PDF_REPORT_MEASURED_DETAIL_NUMBER: 'Report No. :',
        PDF_REPORT_MEASURABLE_DETAIL_NUMBER: 'Measured detail No. :',
        PDF_REPORT_MEASURER: 'Measured by :',
        PDF_REPORT_TIME: 'Time :',
        // PDF Report table headers
        PDF_REPORT_TABLE_M_NR: 'Pos nr',
        PDF_REPORT_TABLE_NOMINAL_DIM: 'Nominal',
        PDF_REPORT_TABLE_TOLERANCE: 'Tolerance',
        PDF_REPORT_TABLE_MIN: 'Min',
        PDF_REPORT_TABLE_MAX: 'Max',
        PDF_REPORT_TABLE_MEASURED: 'Actual',
        PDF_REPORT_TABLE_TOOL: 'Tool',
        PDF_REPORT_TABLE_RESULT: 'Result',
        PDF_REPORT_TABLE_TIME: 'Time',
        PDF_REPORT_TOOLS_TABLE_TITLE: 'Used Tools',
        PDF_REPORT_TOOLS_TABLE_NUMBER: 'Number',
        PDF_REPORT_TOOLS_TABLE_NAME: 'Name',
        PDF_REPORT_TOOLS_TABLE_PRECISION_CLASS: 'Precision Class',
        PDF_REPORT_TOOLS_TABLE_PICTURE: 'Picture',
        PDF_REPORT_YES: 'Yes',
        PDF_REPORT_NO: 'No',
    },
    ru: {
        // App title
        APP_TITLE: 'QUALITY DATUM',
        NO_ORGANIZATION_MESSAGE: 'Свяжитесь с вашим руководителем.',
        NO_TOOLS_MESSAGE: 'Измерительные инструменты отсутствуют. Пожалуйста, свяжитесь с вашим руководителем, чтобы добавить измерительные инструменты.',
        SUBSCRIPTION_INACTIVE_TITLE: 'Подписка неактивна',
        SUBSCRIPTION_INACTIVE_MESSAGE: 'Ваша подписка истекла или была отменена. Пожалуйста, оформите подписку заново на странице профиля, чтобы продолжить управление пользователями и редакторами. Пользователи и редакторы не могут работать, пока вы не оформите подписку заново.',
        SUBSCRIPTION_INACTIVE_ERROR_ADD: 'Подписка неактивна. Пожалуйста, оформите подписку заново на странице профиля, чтобы добавить пользователей.',
        SUBSCRIPTION_INACTIVE_ERROR_ROLE: 'Подписка неактивна. Пожалуйста, оформите подписку заново на странице профиля, чтобы изменить роли пользователей.',

        // Roles
        OPERATOR: 'Оператор',
        ENGINEER: 'Инженер',

        // Form labels
        DETAIL_NUMBER: 'Номер детали *',
        ORDER_NUMBER: 'Номер заказа *',
        MEASURED_DETAIL_NUMBER: 'Номер отчёта об измерении *',
        REVISION_LABEL: 'Ревизия *',

        // Buttons
        SELECT_NEW: 'ВЫБРАТЬ НОВЫЙ',
        SELECT: 'ВЫБРАТЬ',
        CONTINUE: 'ПРОДОЛЖИТЬ',

        // File types
        PDF: 'PDF',
        XLSX: 'XLSX',

        // Error messages
        INVALID_PDF_FILE: 'Импортированный файл не подходит. Пожалуйста, выберите PDF-файл.',
        INVALID_EXCEL_FILE: 'Импортированный файл не подходит. Пожалуйста, выберите Excel-файл.',

        // Icons/symbols
        ARROW: '→',
        FILE_ICON: '📄',

        // PDF Viewer strings
        BACK_BUTTON: 'Назад',
        SAVE_BUTTON: 'Сохранить',
        ORDER_NUMBER_LABEL: 'Номер заказа:',
        EDITOR_SAVE_ORDER_NUMBER_DIALOG_TITLE: 'Введите номер заказа',
        EDITOR_SAVE_PDF_MEASURED_DETAIL_LABEL: 'Номер измеренной детали:',
        ENGINEER_NAME_LABEL: 'Имя инженера:',
        ENGINEER_NAME: 'Вася Пупкин',
        DETAIL_NUMBER_LABEL: 'Номер детали:',
        MEASURED_DETAIL_NUMBER_LABEL: 'Номер отчёта об измерении:',

        // Loading states
        LOADING: 'Загрузка...',

        // PDF loading states
        PDF_LOADING: 'Загружаю PDF файл...',
        PDF_ERROR: 'Не удалось загрузить PDF файл.',
        PDF_NOT_SELECTED: 'PDF файл не выбран.',
        NO_PDF_FILE_SELECTED: 'PDF файл не выбран.',

        G2_RECOGNIZED_LABEL: 'Распознанный стандарт:',
        ISO22081_LINEAR_SIZES: 'Линейные размеры',
        ISO22081_RADIUS_CHAMFER_SIZES: 'Радиус и фаска (R, C)',
        ISO22081_SHAPE_SIZES: 'Размеры формы',
        ISO22081_ANGULAR_SIZES: 'Угловые размеры',

        HELP_BUTTON_TITLE: 'Горячие клавиши',
        HELP_MENU_TITLE: 'Горячие клавиши',
        HELP_ENTER: 'Сохранить / подтвердить',
        HELP_F2: 'Сохранить / подтвердить',
        HELP_F1: 'Сохранить / подтвердить',
        HELP_DELETE: 'Удалить прямоугольник',
        HELP_F4: 'Удалить прямоугольник',
        HELP_ESCAPE: 'Закрыть меню / удалить неподтверждённый прямоугольник',
        HELP_ESCAPE_USER: 'Закрыть меню',
        HELP_TOOL_SELECT: 'Выбрать инструмент',
        HELP_PLUS: 'Выбрать OK',
        HELP_MINUS: 'Выбрать Нет',
        HELP_CLOSE: 'Закрыть',

        SETTINGS_BUTTON_TITLE: 'Настройки',
        SETTINGS_MENU_TITLE: 'Настройки PDF',
        SETTINGS_SEQUENCE_MEASUREMENT: 'Последовательное измерение',
        SETTINGS_EXAM_MODE: 'Экзамен',
        EXAM_SELECT_TOOL: 'Выберите инструмент',
        EXAM_TOOL_CORRECT: 'Правильный инструмент',
        EXAM_TOOL_INCORRECT: 'Неправильный инструмент',
        SETTINGS_DOWNLOAD_PATH: 'Папка отчётов',
        SETTINGS_SETTINGS_PDF_PATH: 'Папка настроек',
        SETTINGS_CHOOSE_FOLDER: 'Выбрать папку',
        SETTINGS_CLEAR_FOLDER: 'Очистить',
        SETTINGS_FOLDER_NOT_SELECTED: 'Папка не выбрана',
        SETTINGS_APPLY: 'Применить',
        SAVE_SUCCESS_TITLE: 'Сохранено успешно!',
        SAVE_SUCCESS_TITLE_LOCAL_SERVER: 'Сохранено на локальном сервере компании!',
        SAVE_SUCCESS_PATH: 'Файл: {fileName}\nПапка: {folderName}',
        SAVE_SUCCESS_DEFAULT_FOLDER: 'Папка загрузок по умолчанию',
        SAVE_SUCCESS_FILE_LABEL: 'Файл',
        SAVE_SUCCESS_FOLDER_LABEL: 'Папка',
        SAVE_SUCCESS_OPEN_PDF: 'Открыть PDF',
        SAVE_SUCCESS_OK: 'OK',

        // Pagination
        PREVIOUS_PAGE: 'Предыдущая',
        NEXT_PAGE: 'Следующая',
        PAGE_LABEL: 'Страница',
        PAGE: 'Страница',

        // Context menu and inputs
        MEASUREMENT_TOOL_PLACEHOLDER: '...',
        TOOL_NUMBER_PLACEHOLDER: '...',
        NOMINAL_DIMENSION_LABEL: 'Номинальный размер',
        NOMINAL_DIMENSION_PLACEHOLDER: '...',
        DESCRIPTION_LABEL: 'Описание',
        TOLERANCE_PLUS_LABEL: '+',
        TOLERANCE_MINUS_LABEL: '-',
        TOLERANCE_PLUS_PLACEHOLDER: '...',
        TOLERANCE_MINUS_PLACEHOLDER: '...',
        MEASUREMENT_RESULT_PLACEHOLDER: '0.00',

        // Tolerance buttons
        SMALL_TOLERANCE_BUTTON: '+ -',
        MEDIUM_TOLERANCE_BUTTON: '+ +',
        LARGE_TOLERANCE_BUTTON: '- -',

        // Excel export headers
        MEASUREMENT_NUMBER: 'Измерение',
        TOOL: 'Инструмент',
        NOMINAL_DIMENSION: 'Номинальный размер',
        MEASUREMENT_RESULT: 'Результат измерения',
        RESULT: 'Результат',
        MEASURED_DETAIL_NUMBER_EXPORT: 'Номер отчёта об измерении',
        COMPLETED: 'Завершено?',
        TOLERANCE_PLUS: 'Верхний допуск',
        TOLERANCE_MINUS: 'Нижний допуск',
        TOLERANCE_TYPE: 'Тип допуска',
        TIME: 'Время',
        X_POSITION: 'X позиция',
        Y_POSITION: 'Y позиция',
        WIDTH: 'Ширина',
        HEIGHT: 'Высота',
        DETAIL_NUMBER_EXPORT: 'Номер детали',

        // Boolean values
        YES: 'Да',
        NO: 'Нет',

        // File names
        UNKNOWN: 'неизвестно',
        SETUP_DATA_SHEET: 'Данные настройки',
        USER_REPORT_DATA_SHEET: 'Измерения',

        // Error messages
        ROLE_SELECTION_ERROR: 'Роль должна быть выбрана. Пожалуйста, выберите оператора или инженера.',

        // Measurement tools
        CALIPER: 'Штангенциркуль',
        CALIBER_TOOL: 'Штангенциркуль',
        MICROMETER: 'Микрометр',
        DIGITAL_INSIDE_MICROMETER: 'Внутренний микрометр',
        DIAL_INDICATOR: 'Индикатор часового типа',
        STOPWATCH: 'Индикатор часового типа',
        HEIGHT_GAUGE: 'Высотомер',
        HEIGHT_MEASURING_JACK: 'Высотомер',
        THREAD_GAUGE: 'Резьбовой калибр',
        SCREW_DRIVER: 'Резьбовой калибр',
        TOOL_7: 'NO-GO резьбовой кольцевой калибр',
        TOOL_8: 'GO резьбовой кольцевой калибр',
        TOOL_9: '3-точечный внутренний микрометр',
        TOOL_10: 'Глубинный микрометр',
        TOOL_11: 'Калибр-штифт',
        MULTIMETER: 'Мультиметр',

        // Registration page
        USERNAME_LABEL: 'Имя пользователя',
        USERNAME_PLACEHOLDER: 'Введите имя пользователя',
        EMAIL_LABEL: 'Электронная почта',
        EMAIL_PLACEHOLDER: 'Введите адрес электронной почты',
        PASSWORD_LABEL: 'Пароль',
        PASSWORD_PLACEHOLDER: 'Введите пароль',
        CONFIRM_PASSWORD_LABEL: 'Подтвердите пароль',
        CONFIRM_PASSWORD_PLACEHOLDER: 'Подтвердите пароль',
        ORGANIZATION_LABEL: 'Организация',
        ORGANIZATION_PLACEHOLDER: 'Введите название компании, кратко',
        ORGANIZATION_IMAGE_LABEL: 'Логотип (PNG или JPEG)',
        ORGANIZATION_LOGO_REQUIRED_ERROR: 'Пожалуйста, выберите логотип компании (PNG или JPEG).',
        ORGANIZATION_LOGO_FORMAT_ERROR: 'Логотип компании должен быть в формате PNG или JPEG.',
        ORGANIZATION_LOGO_PREVIEW: 'Предпросмотр логотипа организации',
        USE_DEFAULT_LOGO_LABEL: 'Использовать логотип по умолчанию',
        OR_LABEL: 'или',
        ROLE_LABEL: 'Роль',
        SELECT_ROLE_PLACEHOLDER: 'Выберите роль',
        ROLE1: 'Руководитель',
        ROLE2: 'Пользователь',

        // Pricing plans
        PRICING_PLANS_TITLE: 'Выберите план',
        YOUR_PLAN_TITLE: 'Ваш план',
        BASIC_PLAN_TITLE: 'Basic',
        PREMIUM_PLAN_TITLE: 'Premium',
        ULTIMATE_PLAN_TITLE: 'Ultimate',
        MONTHLY_PRICE: 'EUR/месяц',
        EDITORS_LABEL: 'редакторов',
        USERS_LABEL: 'пользователей',
        MEASUREMENT_TOOLS_LABEL: 'измерительных инструментов',
        ADDITIONAL_TOOLS_LABEL: 'дополнительных измерительных инструментов',
        ADDITIONAL_TOOL_PRICE: 'EUR/месяц за каждый дополнительный инструмент',
        UNLIMITED_LABEL: 'неограниченно',
        SELECT_PLAN_BUTTON: 'Выбрать план',
        PLAN_ACTIVATED_BUTTON: 'Активен',
        CONTACT_US_BUTTON: 'Подать заявку',
        PLAN_DOWNGRADE_WARNING_TITLE: 'Предупреждение: Изменение плана',
        PLAN_DOWNGRADE_WARNING_MESSAGE: 'Если вы перейдете на более дешевый план, все ваши пользователи и редакторы будут удалены. Это действие необратимо. Вы хотите продолжить?',
        PLAN_DOWNGRADE_CONFIRM_BUTTON: 'Продолжить',
        PLAN_DOWNGRADE_CANCEL_BUTTON: 'Отмена',

        REGISTER_BUTTON: 'Зарегистрироваться',
        REGISTERING_BUTTON: 'Регистрация...',
        PASSWORDS_DONT_MATCH_ERROR: 'Пароли не совпадают',
        PASSWORD_TOO_SHORT_ERROR: 'Пароль должен содержать минимум 8 символов',
        PASSWORD_TOO_LONG_ERROR: 'Пароль не должен быть длиннее 128 символов',
        PASSWORD_MISSING_UPPERCASE_ERROR: 'Пароль должен содержать минимум одну заглавную букву (A-Z)',
        PASSWORD_MISSING_LOWERCASE_ERROR: 'Пароль должен содержать минимум одну строчную букву (a-z)',
        PASSWORD_MISSING_DIGIT_ERROR: 'Пароль должен содержать минимум одну цифру (0-9)',
        PASSWORD_MISSING_SPECIAL_CHAR_ERROR: 'Пароль должен содержать минимум один специальный символ (!@#$%^&*()_+-=[]{}|;:,.<>?)',
        PASSWORD_REPEATED_CHARS_ERROR: 'Пароль не должен содержать повторяющиеся символы подряд',
        PASSWORD_COMMON_SEQUENCE_ERROR: 'Пароль не должен содержать распространенные последовательности (123, abc, qwe и т.д.)',
        FILL_ALL_FIELDS_ERROR: 'Пожалуйста, заполните все поля',
        REGISTRATION_ERROR: 'Произошла ошибка при регистрации',
        REGISTRATION_SUCCESS: 'Регистрация прошла успешно!',
        REGISTRATION_RATE_LIMIT_ERROR: 'Слишком много попыток регистрации. Пожалуйста, попробуйте позже.',
        REGISTRATION_RATE_LIMIT_MESSAGE: 'Пожалуйста, подождите перед следующей попыткой',

        // Payment Error Messages
        PAYMENT_ERROR: 'Ошибка оплаты',
        PAYMENT_CANCELLED: 'Оплата отменена',
        PAYMENT_FAILED: 'Оплата не прошла',
        PAYMENT_PROCESSING_ERROR: 'Ошибка обработки оплаты',
        PAYMENT_SESSION_EXPIRED: 'Сессия оплаты истекла',
        PAYMENT_NOT_COMPLETED: 'Оплата не завершена',
        PROCESSING_PAYMENT: 'Обрабатываем платеж...',
        PLEASE_WAIT: 'Пожалуйста, подождите',

        // Password re-entry after payment (security feature)
        PAYMENT_SUCCESS_ENTER_PASSWORD_TITLE: 'Оплата прошла успешно',
        PAYMENT_SUCCESS_ENTER_PASSWORD_DESC: 'Для безопасности введите пароль для завершения регистрации.',
        COMPLETE_REGISTRATION_BUTTON: 'Завершить регистрацию',

        // Firebase Auth Error Messages
        FIREBASE_EMAIL_ALREADY_IN_USE: 'Этот адрес электронной почты уже используется',
        FIREBASE_INVALID_EMAIL: 'Неверный адрес электронной почты',
        FIREBASE_OPERATION_NOT_ALLOWED: 'Эта операция не разрешена',
        FIREBASE_WEAK_PASSWORD: 'Пароль слишком слабый',
        FIREBASE_USER_DISABLED: 'Этот пользователь отключен',
        FIREBASE_USER_NOT_FOUND: 'Пользователь не найден',
        FIREBASE_WRONG_PASSWORD: 'Неверный пароль',
        FIREBASE_INVALID_CREDENTIAL: 'Неверное имя пользователя или пароль',
        FIREBASE_TOO_MANY_REQUESTS: 'Слишком много неудачных попыток. Попробуйте позже',
        FIREBASE_NETWORK_REQUEST_FAILED: 'Ошибка сети. Проверьте подключение к интернету',
        FIREBASE_REQUIRES_RECENT_LOGIN: 'Эта операция требует недавнего входа в систему',

        // Login page
        LOGIN_EMAIL_LABEL: 'Электронная почта',
        LOGIN_EMAIL_PLACEHOLDER: 'Введите адрес электронной почты',
        LOGIN_PASSWORD_LABEL: 'Пароль',
        LOGIN_PASSWORD_PLACEHOLDER: 'Введите пароль',
        LOGIN_BUTTON: 'Войти',
        LOGIN_LOADING: 'Вход в систему...',
        LOGIN_ERROR: 'Произошла ошибка при входе',
        LOGIN_FILL_FIELDS_ERROR: 'Пожалуйста, введите адрес электронной почты и пароль',
        FORGOT_PASSWORD_BUTTON: 'Забыли пароль?',
        FORGOT_PASSWORD_ALERT: 'Функция восстановления пароля скоро появится!',
        RESET_PASSWORD_TITLE: 'Восстановление пароля',
        RESET_PASSWORD_EMAIL_LABEL: 'Адрес электронной почты',
        RESET_PASSWORD_EMAIL_PLACEHOLDER: 'Введите ваш адрес электронной почты',
        RESET_PASSWORD_EMAIL_REQUIRED: 'Пожалуйста, введите адрес электронной почты',
        RESET_PASSWORD_ERROR: 'Ошибка при восстановлении пароля',
        RESET_PASSWORD_SUCCESS: 'Ссылка для восстановления пароля отправлена на ваш адрес электронной почты.',
        RESET_PASSWORD_INSTRUCTIONS: 'Пожалуйста, проверьте вашу электронную почту и следуйте инструкциям для восстановления пароля.',
        RESET_PASSWORD_CANCEL: 'Отмена',
        RESET_PASSWORD_SENDING: 'Отправка...',
        RESET_PASSWORD_SEND: 'Отправить',

        // Contact Us page
        CONTACT_US_TITLE: 'Связь с нами',
        CONTACT_US_DESCRIPTION: 'Если Вы хотите обсудить наш продукт или вы хотите получить предложение на персональную версию, заполните форму.',
        NAME_LABEL: 'Имя',
        NAME_PLACEHOLDER: 'Введите ваше имя',
        COMPANY_LABEL: 'Компания',
        COMPANY_PLACEHOLDER: 'Введите название компании',
        PHONE_LABEL: 'Телефон',
        PHONE_PLACEHOLDER: 'Введите номер телефона',
        MESSAGE_LABEL: 'Сообщение',
        MESSAGE_PLACEHOLDER: 'Опишите ваши потребности и вопросы...',
        SEND_MESSAGE_BUTTON: 'Отправить сообщение',
        SENDING_MESSAGE_BUTTON: 'Отправляем...',
        MESSAGE_SENT_SUCCESS: 'Сообщение отправлено успешно!',
        MESSAGE_SENT_ERROR: 'Ошибка при отправке сообщения',
        REQUIRED_FIELD_ERROR: 'Это поле обязательно',
        INVALID_EMAIL_ERROR: 'Пожалуйста, введите действительный адрес электронной почты',
        INVALID_PHONE_ERROR: 'Пожалуйста, введите действительный номер телефона',

        // No Connection Page
        NO_CONNECTION_TITLE: 'Нет соединения',
        NO_CONNECTION_DESCRIPTION: 'Для корректной работы приложения необходимо подключение к интернету. Пожалуйста, проверьте ваше интернет-соединение и попробуйте снова.',
        NO_CONNECTION_TIPS_TITLE: 'Проверьте следующее:',
        NO_CONNECTION_TIP_1: 'Наличие интернет-соединения',
        NO_CONNECTION_TIP_2: 'Настройки Wi-Fi или мобильных данных',
        NO_CONNECTION_TIP_3: 'Силу сигнала сети',
        NO_CONNECTION_TIP_4: 'Настройки брандмауэра или безопасности',
        RETRY_BUTTON: 'Попробовать снова',

        // Profile Page
        PROFILE_TITLE: 'Мой профиль',
        PROFILE_NAME_LABEL: 'Имя',
        PROFILE_EMAIL_LABEL: 'Адрес электронной почты',
        PROFILE_EMAIL_VERIFIED_LABEL: 'Электронная почта подтверждена',
        PROFILE_ROLE_LABEL: 'Роль',
        PROFILE_LANGUAGE_LABEL: 'Язык приложения',
        PROFILE_REPORT_LANGUAGE_LABEL: 'Язык отчета',
        PROFILE_LANGUAGE_ET: 'Эстонский',
        PROFILE_LANGUAGE_EN: 'Английский',
        PROFILE_LANGUAGE_RU: 'Русский',
        PROFILE_ORGANIZATION_LABEL: 'Организация',
        PROFILE_ORGANIZATION_PLACEHOLDER: 'Введите название организации',
        PROFILE_SUBSCRIPTION_PLAN_LABEL: 'План подписки',
        PROFILE_EDITOR_LIMIT_LABEL: 'Лимит редакторов',
        PROFILE_USER_LIMIT_LABEL: 'Лимит пользователей',
        PROFILE_SAVE_ORGANIZATION: 'Сохранить организацию',
        PROFILE_SAVING: 'Сохранение...',
        PROFILE_SAVE: 'Сохранить',
        PROFILE_LOGO_LABEL: 'Логотип',
        PROFILE_LOGO_CHANGE: 'Изменить логотип',
        PROFILE_LOGO_USE_DEFAULT: 'Использовать логотип по умолчанию',
        PROFILE_LOGO_SELECT_FILE: 'Выбрать файл',
        PROFILE_LOGO_ERROR_NO_FILE: 'Пожалуйста, выберите файл изображения',
        PROFILE_LOGO_ERROR_UPLOAD: 'Ошибка при сохранении логотипа',
        PROFILE_PDF_WORKFLOW_LABEL: 'Как операторы и редакторы работают с PDF',
        PROFILE_PDF_WORKFLOW_MANUAL: 'Ручной выбор файлов',
        PROFILE_PDF_WORKFLOW_LOCAL_SERVER: 'Локальный сервер',
        PROFILE_PDF_WORKFLOW_CLOUD_DB: 'Cloud DB',
        PROFILE_PDF_WORKFLOW_CLOUD_DB_HELP:
            'Отчёты и настройки сохраняются в облако (Firebase).',
        SAVE_SUCCESS_TITLE_CLOUD_DB: 'Сохранено в облако!',
        PROFILE_PDF_WORKFLOW_MANUAL_HELP:
            'Редактор и оператор вручную выбирают PDF-файлы.',
        LOCAL_SERVER_URL_LABEL: 'URL локального сервера',
        LOCAL_SERVER_ENABLED_LABEL: 'Включён (операторы используют этот сервер)',
        LOCAL_SERVER_LAST_SEEN: 'Последний раз: ',
        LOCAL_SERVER_VERSION_PREFIX: ' (версия ',
        LOCAL_SERVER_NEVER_SEEN: 'Сервер ещё не отчитывался',
        LOCAL_SERVER_COMPANY_ID_LABEL: 'ID компании (для установки локального сервера)',
        LOCAL_SERVER_COMPANY_ID_HINT:
            'Точно это значение вводится в поле Company ID на странице /setup. Можно открыть ссылку http://SERVER_IP:8765/setup?companyId=ТОТ_ЖЕ_ID — SERVER_IP = LAN-адрес сервера, тогда поле подставится само.',
        LOCAL_SERVER_TOKEN_LABEL: 'Регистрационный токен',
        LOCAL_SERVER_TOKEN_BTN: 'Выпустить регистрационный токен',
        LOCAL_SERVER_TOKEN_BTN_LOADING: 'Выпуск...',
        LOCAL_SERVER_TOKEN_HINT: 'Передайте токен IT-инженеру, который ставит локальный сервер. Одноразовый, действителен 24 часа.',
        LOCAL_SERVER_TOKEN_EXPIRES_AT: 'Действителен до: ',
        LOCAL_SERVER_TOKEN_COPY: 'Копировать',
        LOCAL_SERVER_TOKEN_COPIED: 'Скопировано',
        LOCAL_SERVER_TOKEN_ERROR: 'Не удалось выпустить токен',
        LOCAL_SERVER_SAVED: 'Сохранено',
        LOCAL_SERVER_SAVE_ERROR: 'Не удалось сохранить настройки локального сервера',
        LOCAL_SERVER_INVALID_URL: 'URL должен начинаться с https:// или http://',
        LOCAL_SERVER_PUBLISH_FAILED: 'Сохранено локально, но не удалось опубликовать ревизию на локальном сервере: ',
        LOCAL_SERVER_NO_REVISIONS: 'Для этой детали нет опубликованных ревизий',
        HOME_EDITOR_REVISION_UPLOAD_NEW: 'Новая ревизия — загрузить PDF',
        HOME_EDITOR_REVISION_ALREADY_EXISTS: 'Ревизия с таким номером уже существует',
        LOCAL_SERVER_REPORT_UPLOAD_FAILED: 'Сохранение на сервер не удалось. ',
        LOCAL_SERVER_SAVE_FAILED_MODAL_TITLE: 'Не удалось сохранить на сервер',
        REPORTS_NAV_BTN: 'Отчёты',
        REPORTS_TITLE: 'Отчёты',
        REPORTS_FILTER_DETAIL: '№ детали',
        REPORTS_FILTER_ORDER: '№ заказа',
        REPORTS_FILTER_OPERATOR: 'UID оператора',
        REPORTS_APPLY_FILTERS: 'Применить',
        REPORTS_RESET_FILTERS: 'Сбросить',
        REPORTS_EMPTY: 'Отчётов нет',
        REPORTS_TYPE_TO_SEARCH: 'Введите текст в поле поиска выше, чтобы найти отчёты.',
        REPORTS_NEED_LOGIN: 'Пожалуйста, войдите для просмотра отчётов.',
        REPORTS_NO_LOCAL_SERVER: 'Отчёты хранятся на локальном сервере вашей компании. Попросите менеджера настроить его в профиле.',
        REPORTS_COL_DATE: 'Дата',
        REPORTS_COL_DETAIL: 'Деталь',
        REPORTS_COL_REVISION: 'Ревизия',
        REPORTS_COL_ORDER: 'Заказ',
        REPORTS_COL_MEAS_NR: '№ изм.',
        REPORTS_COL_OPERATOR: 'Оператор',
        REPORTS_COL_SIZE: 'Размер',
        REPORTS_COL_ACTION: 'Действие',
        REPORTS_OPEN_REPORT_PDF: 'Открыть PDF отчёта в новой вкладке',
        REPORTS_OPEN_PDF_POPUP_BLOCKED: 'Не удалось открыть PDF: браузер заблокировал новое окно. Разрешите всплывающие окна для этого сайта.',
        REPORTS_DOWNLOAD_REPORT_PDF: 'Скачать PDF отчёта',
        REPORTS_DELETE_CONFIRM_TITLE: 'Подтвердить удаление отчёта',
        REPORTS_DELETE_CONFIRM_LOCAL: 'Удалить этот отчёт с локального сервера безвозвратно?',
        REPORTS_DELETE_CONFIRM_CLOUD: 'Удалить этот отчёт из облачной базы данных безвозвратно?',
        REPORTS_PREV: 'Назад',
        REPORTS_NEXT: 'Далее',
        REPORTS_PAGE_INFO_FORMAT: '{from}–{to} из {total}',
        REPORTS_LOADING: 'Загрузка…',
        SAVED_SETTINGS_TITLE: 'Настройки',
        SAVED_SETTINGS_TYPE_TO_SEARCH: 'Введите текст в поле поиска ниже, чтобы найти PDF ревизий.',
        SAVED_SETTINGS_EMPTY: 'Ничего не найдено',
        SAVED_SETTINGS_OPEN_PDF: 'Открыть PDF настроек в новой вкладке',
        SAVED_SETTINGS_EDIT: 'Редактировать',
        SAVED_SETTINGS_COL_STATUS: 'Статус',
        SAVED_SETTINGS_COL_EDITOR: 'Автор',
        SAVED_SETTINGS_DELETE_CONFIRM_TITLE: 'Подтвердить удаление настроек',
        SAVED_SETTINGS_DELETE_CONFIRM_LOCAL: 'Удалить эту запись сохранённых настроек с локального сервера безвозвратно?',
        SAVED_SETTINGS_DELETE_CONFIRM_CLOUD: 'Удалить эту запись сохранённых настроек из облачной базы данных безвозвратно?',
        PROFILE_LOGOUT: 'Выйти',
        PROFILE_DELETE_PROFILE: 'Удалить профиль',
        PROFILE_DELETING: 'Удаление...',
        PROFILE_DELETE_CONFIRM_TITLE: 'Удалить профиль',
        PROFILE_DELETE_CONFIRM_MESSAGE: 'Вы уверены, что хотите удалить свой профиль? Это действие необратимо, и все ваши данные будут безвозвратно удалены.',
        PROFILE_DELETE_WARNING: 'Предупреждение: Вы не сможете отменить это действие.',
        PROFILE_PASSWORD_CONFIRM_LABEL: 'Пароль для подтверждения',
        PROFILE_PASSWORD_PLACEHOLDER: 'Введите свой пароль',
        PROFILE_CANCEL: 'Отмена',
        PROFILE_DELETE: 'Удалить',
        PROFILE_LOADING_FAILED: 'Не удалось загрузить профиль',
        PROFILE_BACK: 'Назад',
        PROFILE_PROCESSING_PAYMENT: 'Обработка платежа...',
        PROFILE_LOADING: 'Загрузка...',
        PROFILE_PASSWORD_REQUIRED: 'Пожалуйста, введите пароль',
        PROFILE_WRONG_PASSWORD: 'Неверный пароль',
        PROFILE_RELOGIN_REQUIRED: 'Пожалуйста, войдите снова и попробуйте еще раз',
        PROFILE_DELETE_ERROR: 'Ошибка при удалении профиля',
        PROFILE_CHANGE_PASSWORD: 'Изменить пароль',
        PROFILE_CHANGE_PASSWORD_TITLE: 'Изменить пароль',
        PROFILE_CHANGE_PASSWORD_MESSAGE: 'Введите текущий пароль и новый пароль',
        PROFILE_CURRENT_PASSWORD_LABEL: 'Текущий пароль',
        PROFILE_NEW_PASSWORD_LABEL: 'Новый пароль',
        PROFILE_CONFIRM_NEW_PASSWORD_LABEL: 'Подтвердите новый пароль',
        PROFILE_CURRENT_PASSWORD_PLACEHOLDER: 'Введите текущий пароль',
        PROFILE_NEW_PASSWORD_PLACEHOLDER: 'Введите новый пароль',
        PROFILE_CONFIRM_NEW_PASSWORD_PLACEHOLDER: 'Подтвердите новый пароль',
        PROFILE_CHANGING_PASSWORD: 'Изменение пароля...',
        PROFILE_PASSWORD_CHANGED: 'Пароль успешно изменен',
        PROFILE_PASSWORD_CHANGE_ERROR: 'Ошибка при изменении пароля',
        PROFILE_PASSWORD_MISMATCH: 'Новые пароли не совпадают',
        PROFILE_NEW_PASSWORD_REQUIRED: 'Пожалуйста, введите новый пароль',
        PROFILE_CONFIRM_PASSWORD_REQUIRED: 'Пожалуйста, подтвердите новый пароль',
        PROFILE_ORGANIZATION_SAVE_ERROR: 'Ошибка при сохранении организации',
        PROFILE_REMOVE_TOOLS_ERROR: 'Ошибка при удалении инструментов',
        PROFILE_UNKNOWN_ERROR: 'Неизвестная ошибка',
        CHECKOUT_SESSION_ERROR: 'Не удалось создать сессию оплаты',
        ERROR_OCCURRED: 'Произошла ошибка',
        ERROR_REMOVING_MEMBERS: 'Ошибка при удалении членов компании',

        // Roles
        ROLE_ADMIN: 'Администратор',
        ROLE_MANAGER: 'Руководитель',
        ROLE_EDITOR: 'Редактор',
        ROLE_USER: 'Пользователь',

        // Remove Tools Section
        REMOVE_TOOLS_TITLE: 'Удалить инструменты',
        REMOVE_TOOLS_DESCRIPTION: 'Удаляет все инструменты, если вам нужно изменить или удалить неиспользуемые инструменты.',
        REMOVE_TOOLS_CONFIRM_TITLE: 'Подтвердить удаление инструментов',
        REMOVE_TOOLS_CONFIRM_MESSAGE: 'Вы уверены, что хотите удалить все инструменты? Это действие будет стоить 10 EUR и удалит все инструменты (включая пользовательские инструменты и их изображения).',
        REMOVE_TOOLS_CONFIRM: 'Подтвердить',
        REMOVE_TOOLS_PROCESSING: 'Обработка...',

        // Add Tool Confirmation
        ADD_TOOL_CONFIRM_TITLE: 'Добавить инструмент',
        ADD_TOOL_CONFIRM_MESSAGE: 'Вы уверены, что хотите добавить этот инструмент? После добавления удалить или изменить его можно только за дополнительную плату. Информация в настройках профиля.',
        ADD_TOOL_WARNING: 'Предупреждение: Вы не можете бесплатно отменить это действие.',
        ADD_TOOL_CONFIRM: 'Подтвердить',

        // Dashboard Page
        DASHBOARD_ENTER_EMAIL: 'Пожалуйста, введите адрес электронной почты',
        DASHBOARD_ENTER_EMAIL_PLACEHOLDER: 'Введите адрес электронной почты и нажмите Добавить...',
        DASHBOARD_PREVIEW: 'Предпросмотр',
        DASHBOARD_INVALID_EMAIL: 'Неверный адрес электронной почты',
        DASHBOARD_USER_NOT_LOGGED_IN: 'Пользователь не вошел в систему',
        DASHBOARD_ADD_EMAIL_ERROR: 'Ошибка при добавлении электронной почты.',
        DASHBOARD_USER_ALREADY_IN_COMPANY: 'Этот пользователь уже в компании',
        DASHBOARD_ADD_USER_ERROR: 'Ошибка при добавлении пользователя',
        DASHBOARD_USER_ADDED_SUCCESS: 'Пользователь добавлен в компанию',
        DASHBOARD_UPDATE_ROLE_ERROR: 'Ошибка при обновлении роли',
        DASHBOARD_REMOVE_USER_ERROR: 'Ошибка при удалении пользователя',
        DASHBOARD_EDITOR_LIMIT_REACHED: 'Достигнут лимит редакторов',
        DASHBOARD_USER_LIMIT_REACHED: 'Достигнут лимит пользователей',
        DASHBOARD_TOOL_LIMIT_REACHED: 'Достигнут лимит инструментов',
        DASHBOARD_ADD_TOOL_ERROR: 'Ошибка при добавлении инструмента',
        DASHBOARD_REMOVE_TOOL_ERROR: 'Ошибка при удалении инструмента',
        DASHBOARD_DELETE_TOOL: 'Удалить инструмент',
        DASHBOARD_DELETE_TOOL_CONFIRM_TITLE: 'Подтвердить удаление инструмента',
        DASHBOARD_DELETE_TOOL_CONFIRM_MESSAGE: 'Вы уверены, что хотите удалить инструмент',
        DASHBOARD_DELETE_TOOL_WARNING: 'Это действие будет стоить 1 EUR + налог и навсегда удалит этот инструмент (включая изображения пользовательских инструментов, если применимо).',
        DASHBOARD_DELETE_TOOL_CONFIRM: 'Подтвердить и оплатить',
        DASHBOARD_PROCESSING: 'Обработка...',
        DASHBOARD_TOOL_NAME_REQUIRED: 'Пожалуйста, введите название инструмента',
        DASHBOARD_ADD_CUSTOM_TOOL_ERROR: 'Ошибка при добавлении пользовательского инструмента',
        DASHBOARD_SELECT_IMAGE_FILE: 'Пожалуйста, выберите файл изображения',
        DASHBOARD_SELECT_FILE: 'Выбрать файл',
        DASHBOARD_SAVE: 'Сохранить',
        DASHBOARD_DELETE: 'Удалить',
        DASHBOARD_CANCEL: 'Отмена',
        DASHBOARD_EXIT: 'Выход',
        DASHBOARD_ADD_TOOL: 'Добавить инструмент',
        DASHBOARD_ADD_CUSTOM_TOOL: ' Свой инструмент',
        DASHBOARD_SAVING: 'Сохранение...',
        DASHBOARD_ADD: 'Добавить',
        DASHBOARD_SENDING: 'Отправка...',
        DASHBOARD_ADD_CUSTOM_TOOL_TITLE: 'Добавить пользовательский инструмент',
        DASHBOARD_CUSTOM_TOOL_NAME_LABEL: 'Название инструмента *',
        DASHBOARD_CUSTOM_TOOL_NAME_PLACEHOLDER: 'Введите название инструмента',
        DASHBOARD_CUSTOM_TOOL_COLOR_LABEL: 'Цвет *',
        DASHBOARD_SELECT_COLOR: 'Выбрать цвет',
        DASHBOARD_TOOL_COLOR_REQUIRED: 'Цвет обязателен',
        DASHBOARD_IMAGE_FILE_LABEL: 'Файл изображения *',
        DASHBOARD_IMAGE_FILE_NOTE: 'Для лучшего интерфейса в приложении выберите изображение без фона. Изображение должно быть в альбомной ориентации',
        DASHBOARD_IMAGE_FILE_HELP: 'Поддерживаемые форматы: PNG, JPEG, GIF, WebP. Максимальный размер: 5MB',
        DASHBOARD_PRECISION_CLASS_LABEL: 'Класс точности *',
        DASHBOARD_PRECISION_CLASS_PLACEHOLDER: 'Введите класс точности',
        DASHBOARD_PRECISION_CLASS_REQUIRED: 'Класс точности обязателен',
        DASHBOARD_PRECISION_CLASS_HELP: 'Не вводите значения +-. \nПример : введено 0.01, пользователь должен ввести мин. 2 числа после запятой.',
        DASHBOARD_TOOL_WITHOUT_MEASUREMENT: 'Инструмент без измерения',
        DASHBOARD_TOOL_WITHOUT_MEASUREMENT_DESCRIPTION: 'Активируйте, если ваш инструмент имеет фиксированный размер',
        DASHBOARD_MINIMUM_PRECISION_LABEL: 'Минимальная точность числа',
        DASHBOARD_MINIMUM_PRECISION_HELP: 'Минимальная точность значения, которую пользователь должен ввести для отправки измерения.',
        DASHBOARD_TOOL_IMAGE_REQUIRED: 'Файл изображения обязателен',
        DASHBOARD_IMAGE_TOO_LARGE: 'Файл изображения слишком большой (максимум 5MB)',
        DASHBOARD_EDITORS_LABEL: 'Редакторы:',
        DASHBOARD_USERS_LABEL: 'Пользователи:',
        DASHBOARD_TOOLS_LABEL: 'Инструменты:',
        DASHBOARD_MEMBERS_TITLE: 'Работники компании',
        DASHBOARD_TOOLS_TITLE: 'Инструменты',
        DASHBOARD_USER_ROLE: 'Пользователь',
        DASHBOARD_EDITOR_ROLE: 'Редактор',
        DASHBOARD_NO_MEMBERS: 'В компании пока нет членов',
        DASHBOARD_ALL_TOOLS_ADDED: 'Все инструменты уже добавлены',
        DASHBOARD_CONFIRM_DELETE_TITLE: 'Подтвердить удаление',
        DASHBOARD_CONFIRM_DELETE_MESSAGE: 'Вы уверены, что хотите удалить пользователя',
        DASHBOARD_DELETE_WARNING: 'Это действие нельзя отменить.',
        DASHBOARD_LOADING: 'Загрузка...',

        // Home Page
        HOME_EXCEL_ERROR: 'Ошибка при обработке файла Excel',
        HOME_DELETE_FILE: 'Удалить файл',
        PDF_NO_EMBEDDED_SETTINGS: 'PDF файл не содержит настроек. Выберите файл со встроенными настройками.',
        PDF_SETTINGS_EXTRACTED: 'Настройки найдены',
        SAVE_PDF_WITH_SETTINGS: 'Сохранить PDF с настройками',

        // PdfViewer
        PDFVIEWER_NO_TOOLS_MESSAGE: 'Инструменты отсутствуют. Пожалуйста, свяжитесь с вашим руководителем.',
        PDFVIEWER_TOOL_NUMBER_RANGE: 'Пожалуйста, введите число от 1 до',
        PDFVIEWER_MAX_TOOL_NUMBER: 'Максимальное число',
        PDFVIEWER_MIN_TOOL_NUMBER: 'Число должно быть не менее 1',
        PDFVIEWER_HOLE_SHAFT_REQUIRED: 'Вал и отверстие должны быть выбраны в выпадающем меню',
        PDFVIEWER_HOLE_SHAFT_STANDARD_REQUIRED: 'Выберите стандарт вала и отверстия в углу стандартов слева...',
        PDFVIEWER_LOADING: 'Загрузка...',
        PDFVIEWER_RECOGNIZE_REGION: 'Распознать текст в прямоугольнике',
        PDFVIEWER_REGION_OCR_FAILED: 'Умное распознавание не удалось. Попробуйте ещё раз.',
        PDFVIEWER_REGION_OCR_EMPTY: 'В этой области текст не распознан.',
        PDFVIEWER_REGION_OCR_PAGE_NOT_READY: 'Изображение страницы ещё не готово. Дождитесь загрузки и повторите попытку.',
        PDFVIEWER_SETTINGS_TOOL_COUNT_MISMATCH: 'Не удалось загрузить файл. Инструменты компании не совпадают с файлом настроек.',
        REVISION_REQUIRED: 'Ревизия должна быть указана, если в PDF файле нет настроек.',

        // PDF Report strings
        PDF_REPORT_TITLE: 'Отчет об измерениях',
        PDF_REPORT_ORDER: 'Заказ :',
        PDF_REPORT_DETAIL: 'Деталь :',
        PDF_REPORT_REVISION_LABEL: 'Ред. №',
        PDF_REPORT_MEASURED_DETAIL_NUMBER: 'Номер отчёта :',
        PDF_REPORT_MEASURABLE_DETAIL_NUMBER: 'Номер измеренной детали :',
        PDF_REPORT_MEASURER: 'Измерял :',
        PDF_REPORT_TIME: 'Время :',
        // PDF Report table headers
        PDF_REPORT_TABLE_M_NR: 'Позиция №',
        PDF_REPORT_TABLE_NOMINAL_DIM: 'Номинал',
        PDF_REPORT_TABLE_TOLERANCE: 'Допуск',
        PDF_REPORT_TABLE_MIN: 'Мин',
        PDF_REPORT_TABLE_MAX: 'Макс',
        PDF_REPORT_TABLE_MEASURED: 'Замер',
        PDF_REPORT_TABLE_TOOL: 'Инстр.',
        PDF_REPORT_TABLE_RESULT: 'Результ.',
        PDF_REPORT_TABLE_TIME: 'Время',
        PDF_REPORT_TOOLS_TABLE_TITLE: 'Использованные инструменты',
        PDF_REPORT_TOOLS_TABLE_NUMBER: 'Номер',
        PDF_REPORT_TOOLS_TABLE_NAME: 'Название',
        PDF_REPORT_TOOLS_TABLE_PRECISION_CLASS: 'Класс точности',
        PDF_REPORT_TOOLS_TABLE_PICTURE: 'Изображение',
        PDF_REPORT_YES: 'Да',
        PDF_REPORT_NO: 'Нет',
    }
} as const;

// Helper function to get translations for current language
export const getStrings = (language: Language) => TRANSLATIONS[ language ];

// For backward compatibility, export English as default
export const UI_STRINGS = TRANSLATIONS.en; 